import Vue from 'vue';
import Router from 'vue-router';
import login from '@/components/base/login';
import welcome from '@/components/base/welcome';
import loginEditPass from '@/components/base/loginEditPass';
import forget from '@/components/base/forget';
import Public from '@/components/base/Public';
import entryOrderList from '@/components/sellOrderManage/entryOrderList';
import addOrder from '@/components/sellOrderManage/addOrder';
import addProduct from '@/components/sellOrderManage/addProduct';
import remarksReview from '@/components/sellOrderManage/remarksReview';
import NewOrderList from '@/components/sellOrderManage/NewOrderList';
import sellOrderCustomPrint from '@/components/sellOrderManage/sellOrderCustomPrint';
import sellOrderCustomPrintDetail from '@/components/sellOrderManage/sellOrderCustomPrintDetail';
import dailyOrderPrinting from '@/components/sellOrderManage/dailyOrderPrinting';
import sellOrderSupplierPrintDetail from '@/components/sellOrderManage/sellOrderSupplierPrintDetail';
import toBeConfirmePrintDetail from '@/components/sellOrderManage/toBeConfirmePrintDetail';
import newOrderDetail from '@/components/sellOrderManage/newOrderDetail';
import OrderConfirmList from '@/components/sellOrderManage/OrderConfirmList';
import confirmOrderDetail from '@/components/sellOrderManage/confirmOrderDetail';
import HistoryOrderList from '@/components/sellOrderManage/HistoryOrderList';
import historyOrderDetail from '@/components/sellOrderManage/historyOrderDetail';
import complementOutWarehouse from '@/components/sellOrderManage/complementOutWarehouse';
import orderContract from '@/components/sellOrderManage/orderContract';
import AllOrderList from '@/components/sellOrderManage/AllOrderList';
import allOrderDetail from '@/components/sellOrderManage/allOrderDetail';
import sellOrderPrint from '@/components/orderPrint/sellOrderPrint';
import sellAllOrderPrint from '@/components/orderPrint/sellAllOrderPrint';
import sellOrderPrintSelf from '@/components/orderPrint/sellOrderPrintSelf';
import websitePricePrint from '@/components/orderPrint/websitePricePrint';
import websitePricePrintTax from '@/components/orderPrint/websitePricePrintTax';
import s_addOrder from '@/components/shopOrderManage/s_addOrder';
import s_batchAddOrder from '@/components/shopOrderManage/s_batchAddOrder';
import s_distributionCenterPendingOrderDetail from '@/components/shopOrderManage/s_distributionCenterPendingOrderDetail';
import supplierCusNewOrderDetail from '@/components/sellOrderManage/supplierCusNewOrderDetail';
import supplierCusConfirmOrderDetail from '@/components/sellOrderManage/supplierCusConfirmOrderDetail';
import supplierCusHisOrderDetail from '@/components/sellOrderManage/supplierCusHisOrderDetail';
import supplierCusAllOrderDetail from '@/components/sellOrderManage/supplierCusAllOrderDetail';
import SupplementOrder from '@/components/sellOrderManage/SupplementOrder'; // 补单

import reducedOrder from '@/components/sellOrderManage/reducedOrder'; // 资质详情
import priceAudit from '@/components/sellOrderManage/priceAudit'; // 资质详情
import purchaseAudit from '@/components/sellOrderManage/purchaseAudit'; // 采购价审核
import skuAudit from '@/components/sellOrderManage/skuAudit'; // SKU审核
import searchSellOrder from '@/components/sellOrderManage/searchSellOrder'; // SKU审核
import searchSellOrderDetail from '@/components/sellOrderManage/searchSellOrderDetail'; // SKU审核
import supplierSendOrder from '@/components/sellOrderManage/supplierSendOrder'; // 第三方配送订单
import supplierSendOrderDetail from '@/components/sellOrderManage/supplierSendOrderDetail'; // 第三方配送订单详情
import thirdPartyTransferErrorProductList from '@/components/sellOrderManage/thirdPartyTransferErrorProductList'; // 转换存疑产品清单
import thirdPartyTransferErrorProductList_test from '@/components/sellOrderManage/thirdPartyTransferErrorProductList_test'; // 转换存疑产品清单(测试)
import salesPriceReview from '@/components/sellOrderManage/salesPriceReview'; // 销售价复核
import priceAdjustmentRecordsList from '@/components/sellOrderManage/priceAdjustmentRecordsList'; // 订单调价申请记录
import priceAdjustmentDetail from '@/components/sellOrderManage/priceAdjustmentDetail'; // 调价详情
import lowPriceOrderList from '@/components/sellOrderManage/lowPriceOrderList'; // 单外订单
import addLowPriceOrder from '@/components/sellOrderManage/addLowPriceOrder'; // 单外订单-录入订单
import lowPriceOrderListDetail from '@/components/sellOrderManage/lowPriceOrderListDetail'; // 单外订单详情
import appointmentHandling from '@/components/base/appointmentHandling.vue'; // 预约下载
import NoActualOrderConfirmation from '@/components/sellOrderManage/NoActualOrderConfirmation'; // 无实发订单确认

// import s_newOrderPrint from '@/components/shopOrderManage/s_newOrderPrint'
import s_orderCheck from '@/components/shopOrderManage/s_orderCheck';
import s_addProduct from '@/components/shopOrderManage/s_addProduct';
import s_NewOrderList from '@/components/shopOrderManage/s_NewOrderList';
import s_HistoryOrderList from '@/components/shopOrderManage/s_HistoryOrderList';
import s_OrderDetail from '@/components/shopOrderManage/s_OrderDetail';
import purchaseOrder from '@/components/sendDocument/purchaseOrder';
import totalPurchase from '@/components/sendDocument/totalPurchase';
import s_orderPrint from '@/components/shopOrderManage/s_orderPrint';
import historyPrint from '@/components/shopOrderManage/historyPrint';
import historyStorageShortPrint from '@/components/shopOrderManage/historyStorageShortPrint';
import s_historyPrint from '@/components/shopOrderManage/s_historyPrint';
import s_printTax from '@/components/shopOrderManage/s_printTax';
import s_pricePrint from '@/components/shopOrderManage/s_pricePrint';
import s_priceTax from '@/components/shopOrderManage/s_priceTax';
import s_contantract from '@/components/shopOrderManage/s_contantract';
import s_historyContantract from '@/components/shopOrderManage/s_historyContantract';
import purchaseAddProduct from '@/components/shopOrderManage/purchaseAddProduct';
import shopCar from '@/components/shopOrderManage/shopCar';
import emergencyOrder from '@/components/shopOrderManage/emergencyOrder';
import shopConfirmOrderList from '@/components/shopOrderManage/confirmOrderList';
import shopConfirmOrderDetail from '@/components/shopOrderManage/confirmOrderDetail';
import supplierComfirmDetail from '@/components/shopOrderManage/supplierComfirmDetail';
import searchShopOrder from '@/components/shopOrderManage/searchShopOrder';

// 客户管理
import customerList from '@/components/customerManage/customerList';
import projectList from '@/components/customerManage/projectList';
import dkList from '@/components/customerManage/dkList';
import queryProducts from '@/components/customerManage/queryProducts';
import addProductsList from '@/components/customerManage/addProductsList';
import tcCodeManage from '@/components/customerManage/tcCodeManage';
import projectProduct from '@/components/customerManage/projectProduct';
import addProjectProduct from '@/components/customerManage/addProjectProduct';
import personDetail from '@/components/customerManage/personDetail';
import releationManage from '@/components/customerManage/releationManage';
import releationDetail from '@/components/customerManage/releationDetail';
import clientGroup from '@/components/customerManage/clientGroup';
import matchClientGroup from '@/components/customerManage/matchClientGroup';

import sellPrice from '@/components/costCenter/soldPrice';
import shopPrice from '@/components/costCenter/shopPrice';
import soldPriceDetail from '@/components/costCenter/soldPriceDetail';
import orderList from '@/components/costCenter/orderList';
import orderProfitDetail from '@/components/costCenter/orderProfitDetail';

import groupManage from '@/components/systemSetting/groupManage';
import matchGroup from '@/components/systemSetting/matchGroup';
import matchDK from '@/components/systemSetting/matchDK';

import checkDetail from '@/components/audit/checkDetail';
import haveCheckDetail from '@/components/returnCheck/haveCheckDetail';
import haveCheck from '@/components/returnCheck/haveCheck';
import returnOutDetail from '@/components/returnCheck/returnOutDetail';
import returnOutStock from '@/components/returnCheck/returnOutStock';
import GYSHaveCheck from '@/components/returnCheck/GYSHaveCheck';
import stockCheckAudit from '@/components/audit/stockCheckAudit';
import stockCheckAuditDetail from '@/components/audit/stockCheckAuditDetail';

import billingDetails from '@/components/balanceManage/billingDetails';
import invoiceDetail from '@/components/balanceManage/invoiceDetail';

import profitLossTable from '@/components/tableManage/profitLossTable';
import historyInStock from '@/components/tableManage/historyInStock';
import historyInDetail from '@/components/tableManage/historyInDetail';
import priceChangeChart from '@/components/tableManage/priceChangeChart';
import historyOut from '@/components/tableManage/historyOut';
import batchReturnOfInventory from '@/components/tableManage/batchReturnOfInventory';
import singleSalesSummary from '@/components/tableManage/singleSalesSummary';
import itemSalesSchedule from '@/components/tableManage/itemSalesSchedule';
import SupplierPurchaseSchedule from '@/components/tableManage/SupplierPurchaseSchedule';
import historyDetail from '@/components/tableManage/historyDetail';
import deliveryDiscrepancy from '@/components/tableManage/deliveryDiscrepancy';
import purchaseReturnStockOut from '@/components/tableManage/purchaseReturnStockOut';
import purchaseReturnStockOutDetail from '@/components/tableManage/purchaseReturnStockOutDetail';
import businessGrossProfitTable from '@/components/tableManage/businessGrossProfitTable';
import warehouseTransceiverList from '@/components/tableManage/warehouseTransceiverList';
import purchasePriceDifferenceTable from '@/components/tableManage/purchasePriceDifferenceTable';
import purchaseLedger from '@/components/tableManage/purchaseLedger';

// 仓库管理
import stockList from '@/components/warehouseManage/stockList';
import historicalInventory from '@/components/warehouseManage/historicalInventory';
import stockDetail from '@/components/warehouseManage/stockDetail';
import stockOut from '@/components/warehouseManage/stockOut';
import noDocumentMatching from '@/components/warehouseManage/noDocumentMatching';
import matchDocument from '@/components/warehouseManage/matchDocument';
import stockEnter from '@/components/warehouseManage/stockEnter';
import checkStock from '@/components/warehouseManage/checkStock';
import plannedOutbound from '@/components/warehouseManage/plannedOutbound';
// 历史出库单增加补出库
// import ckaddProductRepair from '@/components/tableManage/ckaddProductRepair'
import stockOutDetail from '@/components/warehouseManage/stockOutDetail';
import stockEnterDetail from '@/components/warehouseManage/stockEnterDetail';
import createStock from '@/components/warehouseManage/createStock';
import preview from '@/components/warehouseManage/preview';
import entryStock from '@/components/warehouseManage/entryStock';
import stockListDetail from '@/components/warehouseManage/stockListDetail';
import stockOutNoDetail from '@/components/warehouseManage/stockOutNoDetail';
import ckaddProduct from '@/components/warehouseManage/addProduct';
import adjust from '@/components/warehouseManage/adjust';
import adjust_out from '@/components/warehouseManage/adjust_out';
import adjust_enter from '@/components/warehouseManage/adjust_enter';
import adjust_out_detail from '@/components/warehouseManage/adjust_out_detail';
import adjust_product from '@/components/warehouseManage/adjust_product';
import adjust_enter_detail from '@/components/warehouseManage/adjust_enter_detail';
import warehouseArea from '@/components/warehouseManage/warehouseArea';
import temporaryStock from '@/components/warehouseManage/temporaryStock';
import stockWarning from '@/components/warehouseManage/stockWarning';
import pickingList from '@/components/warehouseManage/pickingList';
import manualInstockDetail from '@/components/warehouseManage/manualInstockDetail';
import secondOut from '@/components/warehouseManage/secondOut';
import pickingListDetail from '@/components/warehouseManage/pickingListDetail';
import returnStock from '@/components/warehouseManage/returnStock';
import temZoneManage from '@/components/warehouseManage/temZoneManage';
import differenceBetweenOutboundAndAcceptance from '@/components/warehouseManage/differenceBetweenOutboundAndAcceptance';
// 出库汇总单
import totalMTSOut from '@/components/warehouseManage/totalMTSOut';
import totalMTOOut from '@/components/warehouseManage/totalMTOOut';
import totalOutWareDoc from '@/components/warehouseManage/totalOutWareDoc';
import totalOutDetail from '@/components/warehouseManage/totalOutDetail';
import reportLoss from '@/components/warehouseManage/reportLoss';
import warehousePosition from '@/components/warehouseManage/warehousePosition';
import manualInstock from '@/components/warehouseManage/manualInstock';
import giftsInstock from '@/components/warehouseManage/giftsInstock';
// 领料单管理
import pickingProduct from '@/components/warehouseManage/pickingProduct';
import pickingShopCar from '@/components/warehouseManage/pickingShopCar';
import pickingDoc from '@/components/warehouseManage/pickingDoc';
import pickingDocDetail from '@/components/warehouseManage/pickingDocDetail';
import pickingOutShortPrint from '@/components/warehouseManage/pickingOutShortPrint';
import pickingOutShortPrintTax from '@/components/warehouseManage/pickingOutShortPrintTax';
import departmentManage from '@/components/warehouseManage/departmentManage';
import pickingDocReturn from '@/components/warehouseManage/pickingDocReturn';
import pickingDocReturnDetail from '@/components/warehouseManage/pickingDocReturnDetail';
import manualStockOut from '@/components/warehouseManage/manualStockOut';
import safetyStockWarning from '@/components/warehouseManage/safetyStockWarning';

import firstOrderPrint from '@/components/orderPrint/firstOrderPrint';
import printPreviewCustom from '@/components/sellOrderManage/printPreviewCustom';
import selfOrderCheck from '@/components/sellOrderManage/selfOrderCheck';
import changeProductsAfterConversion from '@/components/sellOrderManage/changeProductsAfterConversion'; // 转换后变更产品
import selfOrderPrintBySequence from '@/components/orderPrint/selfOrderPrintBySequence';

// 报价
import quote from '@/components/priceManagement/quote';
import expressSalePricing from '@/components/priceManagement/expressSalePricing';
import periodicQuotation from '@/components/priceManagement/periodicQuotation';
import viewPrice from '@/components/priceManagement/viewPrice';
import supplierProduct from '@/components/priceManagement/supplierProduct';
import SubmitPrice from '@/components/priceManagement/SubmitPrice';
import configPrice from '@/components/priceManagement/configPrice';
import checkSku from '@/components/priceManagement/checkSku';
import compareDetail from '@/components/priceManagement/compareDetail';
import inputData from '@/components/priceManagement/inputData';
import comparePrice from '@/components/priceManagement/comparePrice';
import supplierDetail from '@/components/priceManagement/supplierDetail';
import compareList from '@/components/priceManagement/compareList';
import givePrice from '@/components/priceManagement/givePrice';
import checkProductPrice from '@/components/priceManagement/checkProductPrice';
import scName from '@/components/priceManagement/scName';
import suPriceDetail from '@/components/priceManagement/suPriceDetail';
import purchaseQuotation from '@/components/priceManagement/purchaseQuotation';
import quoteDetails from '@/components/priceManagement/quoteDetails';
import mealCheckProductPrice from '@/components/priceManagement/mealCheckProductPrice';
import priceGroup from '@/components/priceManagement/priceGroup';
import matchPriceGroup from '@/components/priceManagement/matchPriceGroup';
import customerPricingReview from '@/components/priceManagement/customerPricingReview';
import businessReferencePrice from '@/components/priceManagement/businessReferencePrice';
import salesPriceInquiry from '@/components/priceManagement/salesPriceInquiry';
import purchasePriceInquiry from '@/components/priceManagement/purchasePriceInquiry';
import customerPricingDifferenceQuery from '@/components/priceManagement/customerPricingDifferenceQuery';
import priceIncreaseRelationshipManagement from '@/components/priceManagement/priceIncreaseRelationshipManagement';

import priceRules from '@/components/priceManagement/priceRules';
import newAddPrice from '@/components/priceManagement/newAddPrice';
import updateAddPrice from '@/components/priceManagement/updateAddPrice';
import priceRangePlus from '@/components/priceManagement/priceRangePlus';
import specialPrice from '@/components/priceManagement/specialPrice';
import newProjectProduct from '@/components/priceManagement/newProjectProduct';
import priceComparitionResult from '@/components/priceManagement/priceComparitionResult';
import supplierPrice from '@/components/priceManagement/supplierPrice';
import orderProfitAnalysis from '@/components/priceManagement/orderProfitAnalysis';
import projectProfitAnalysis from '@/components/priceManagement/projectProfitAnalysis';


import delayedReview from '@/components/audit/delayedReview';
import returnAudit from '@/components/audit/returnAudit';
import returnAuditSupplierCusDetail from '@/components/audit/returnAuditSupplierCusDetail';
import matchProduct from '@/components/systemSetting/matchProduct';
import kindManage from '@/components/systemSetting/kindManage';
import kindProduct from '@/components/systemSetting/kindProduct';
import addKindProduct from '@/components/systemSetting/addProduct';
import kindAddPoint from '@/components/systemSetting/kindAddPoint';


// 报表
import returnWarehouse from '@/components/tableManage/returnWarehouse';
import returnWareDetail from '@/components/tableManage/returnWareDetail';
import returnProduct from '@/components/tableManage/returnProduct';
import returnProductDetail from '@/components/tableManage/returnProductDetail';
import enterPurchaseReturnOrder from '@/components/tableManage/enterPurchaseReturnOrder';
import productRankList from '@/components/tableManage/productRankList';
import singleRange from '@/components/tableManage/singleRange';
import returnGoods from '@/components/tableManage/returnGoods';
import returnGoodsDetail from '@/components/tableManage/returnGoodsDetail';
import SupplierCusSalesReturnProductDetail from '@/components/tableManage/SupplierCusSalesReturnProductDetail';
import supplierSingleItemProcurementSummary from '@/components/tableManage/supplierSingleItemProcurementSummary';
import returnWareSupplierCusDetail from '@/components/tableManage/returnWareSupplierCusDetail';
import dataBoard from '@/components/tableManage/dataBoard';
import projectSalesDailySummary from '@/components/tableManage/projectSalesDailySummary';

// 分拣配送 开始
import sendingDocument from '@/components/sortingAndDistribution/sendingDocument';
import separateDoc from '@/components/sortingAndDistribution/separateDoc';
import separateDetail from '@/components/sortingAndDistribution/separateDetail';
import separateRemarks from '@/components/sortingAndDistribution/separateRemarks';
import lineSet from '@/components/sortingAndDistribution/lineSet';
import lineSetDetail from '@/components/sortingAndDistribution/lineSetDetail';
import carSet from '@/components/sortingAndDistribution/carSet';
import accountManagement from '@/components/sortingAndDistribution/accountManagement';
import matchCar from '@/components/sortingAndDistribution/matchCar';
import monitor from '@/components/sortingAndDistribution/monitor';
import deliveryTaskProgress from '@/components/sortingAndDistribution/deliveryTaskProgress';
// 打印标签
import s_print from '@/components/sortingAndDistribution/s_print';
import sortingGroupManagement from '@/components/sortingAndDistribution/sortingGroupManagement';
import sortingGroupMatchedProjrct from '@/components/sortingAndDistribution/sortingGroupMatchedProjrct';
import sortingGroupMatchProjrct from '@/components/sortingAndDistribution/sortingGroupMatchProjrct';
import sortingVarianceQuery from '@/components/sortingAndDistribution/sortingVarianceQuery';
import turnoverManage from '@/components/sortingAndDistribution/turnoverManage';
import turnoverList from '@/components/sortingAndDistribution/turnoverList';
// 分拣配送 结束

// 采买单
import detailPurchase from '@/components/sendDocument/detailPurchase';
import productMatch from '@/components/sendDocument/productMatch';
import PurchaseMatchProduct from '@/components/sendDocument/PurchaseMatchProduct';

// 出库汇总单
import totalOutWare from '@/components/sendDocument/totalOutWare';
// 制单管理  采买单管理
import shoppingDocument from '@/components/sendDocument/shoppingDocument';

// 运营中心
import clearing from '@/components/operationCenter/clearing';
import clearingDetail from '@/components/operationCenter/clearingDetail';
import clearingCheck from '@/components/operationCenter/clearingCheck';
import clearingArea from '@/components/operationCenter/clearingArea';
import clearingParameter from '@/components/operationCenter/clearingParameter';
import costReport from '@/components/operationCenter/costReport';
import categoryCost from '@/components/operationCenter/categoryCost';
import costSecondType from '@/components/operationCenter/costSecondType';
// 账号管理
import accountManager from '@/components/operationCenter/accountManager';
import queryRole from '@/components/operationCenter/queryRole';
import matchRole from '@/components/operationCenter/matchRole';


// 生产加工 开始
import proPickingProduct from '@/components/productionProcessing/proPickingProduct';
import proPickingShopCar from '@/components/productionProcessing/proPickingShopCar';
import proPickingDoc from '@/components/productionProcessing/proPickingDoc';
import proPickingDocDetail from '@/components/productionProcessing/proPickingDocDetail';
import proPickingResult from '@/components/productionProcessing/proPickingResult';
import purchaseProduct from '@/components/productionProcessing/purchaseProduct';
import proPickingDocReturn from '@/components/productionProcessing/proPickingDocReturn';
import proPickingDocReturnDetail from '@/components/productionProcessing/proPickingDocReturnDetail';
// 生产配置
import productionSet from '@/components/productionProcessing/productionSet';
import addProduction from '@/components/productionProcessing/addProduction';
import productionDetail from '@/components/productionProcessing/productionDetail';
import addProductionDetail from '@/components/productionProcessing/addProductionDetail';
import productDepartment from '@/components/productionProcessing/productDepartment';// 生产部门
import dishManagement from '@/components/productionProcessing/dishManagement';
import addDish from '@/components/productionProcessing/addDish';
import ingredientsDetail from '@/components/productionProcessing/ingredientsDetail';
import addIngredients from '@/components/productionProcessing/addIngredients';
// 生产入库
import proWarehousing from '@/components/productionProcessing/proWarehousing';
import proWarehousingDetails from '@/components/productionProcessing/proWarehousingDetails';
import proManualWarehousing from '@/components/productionProcessing/proManualWarehousing';
import proReceipt from '@/components/productionProcessing/proReceipt';
import proReceiptDetails from '@/components/productionProcessing/proReceiptDetails';
// 套餐管理
import packageSet from '@/components/productionProcessing/packageSet';
import mealCountSet from '@/components/productionProcessing/mealCountSet';
import matchDishes from '@/components/productionProcessing/matchDishes';
import mealGroup from '@/components/productionProcessing/mealGroup';
import editRecipe from '@/components/productionProcessing/editRecipe';
// 生产汇总单
import totalSellProducts from '@/components/productionProcessing/totalSellProducts';
import sellProductsDetail from '@/components/productionProcessing/sellProductsDetail';
import produceDetail from '@/components/productionProcessing/produceDetail';
import addProProduct from '@/components/productionProcessing/addProProduct';
import transferShop from '@/components/productionProcessing/transferShop';
// 生产加工 结束

// 报表
import salesStatements from '@/components/tableManage/salesStatements';
import salesStatementsDetail from '@/components/tableManage/salesStatementsDetail';
import grossProfit from '@/components/tableManage/grossProfit';
import purchase from '@/components/tableManage/purchase';
import purchaseDetail from '@/components/tableManage/purchaseDetail';
import TCGrossProfit from '@/components/tableManage/TCGrossProfit';
import TCGrossProfitDetail from '@/components/tableManage/TCGrossProfitDetail';
import orderCostGrossProfit from '@/components/tableManage/orderCostGrossProfit';
import projectPointGrossProfitTable from '@/components/tableManage/projectPointGrossProfitTable';
import orderProductGrossProfitTable from '@/components/tableManage/orderProductGrossProfitTable';


// 采购订单短打印
import shortOrderPrint from '@/components/shopOrderManage/shortOrderPrint';
import shortPrintTax from '@/components/shopOrderManage/shortPrintTax';
import historyShortPrint from '@/components/shopOrderManage/historyShortPrint';

// 出库汇总单退货
import sellOrderReturn from '@/components/tableManage/sellOrderReturn';
import sellOrderReturnDetail from '@/components/tableManage/sellOrderReturnDetail';

// 溯源
import productTracing from '@/components/tracing/productTracing';
import tracingContract from '@/components/tracing/tracingContract';
import supplierContract from '@/components/tracing/supplierContract';
import supplierImg from '@/components/tracing/supplierImg';

// 供应商客户订单打印
import supplierCusOrderPrint from '@/components/orderPrint/supplierCusOrderPrint';
import sellOrderFivePrint from '@/components/orderPrint/sellOrderFivePrint';

// SKU管理
import categoryManage from '@/components/SKUManage/categoryManage';
import secondCategory from '@/components/SKUManage/secondCategory';
import thirdCategory from '@/components/SKUManage/thirdCategory';
import forthCategory from '@/components/SKUManage/forthCategory';
import useSku from '@/components/SKUManage/useSku';
import productionEnterpriseManagement from '@/components/SKUManage/productionEnterpriseManagement';
import productQualification from '@/components/SKUManage/productQualification';
import matchSku from '@/components/SKUManage/matchSku';
import staticSku from '@/components/SKUManage/staticSku';
import canInput from '@/components/SKUManage/canInput';
import skuDetail from '@/components/SKUManage/skuDetail';
// SMP标准SKU
import marryPageSku from '@/components/SKUManage/marryPageSku';
import applicationSku from '@/components/SKUManage/applicationSku';
import changeKeepSku from '@/components/SKUManage/changeKeepSku';
import specialOut from '@/components/SKUManage/specialOut';
import productTax from '@/components/SKUManage/productTax';
import productApplication from '@/components/SKUManage/productApplication.vue';
import supplierTax from '@/components/SKUManage/supplierTax';
import kindTax from '@/components/SKUManage/kindTax';
import productManage_supplier from '@/components/SKUManage/productManage_supplier';
import productManage_kind from '@/components/SKUManage/productManage_kind';
// 产品备货方案
import productStockingPlan from '@/components/SKUManage/productStockingPlan';
import unpackInfo from '@/components/SKUManage/unpackInfo';


// 财务中心
import bankAccount from '@/components/financeCenter/bankAccount';
import bankAccountDetail from '@/components/financeCenter/bankAccountDetail';
import cashFlow from '@/components/financeCenter/cashFlow';
import customerSettlement from '@/components/financeCenter/customerSettlement';
import tcBalance from '@/components/financeCenter/TCBalanceList';
import customerBalance from '@/components/financeCenter/customerBalance';
import customerOrderDayList from '@/components/financeCenter/customerOrderDayList';
import tcOrderList from '@/components/financeCenter/tcOrderList';
import tcBalanceDayList from '@/components/financeCenter/tcBalanceDayList';
import customerDetail from '@/components/financeCenter/customerDetail';
import settlementOrderContract from '@/components/financeCenter/settlementOrderContract';
import tcBillingDetails from '@/components/financeCenter/tcBillingDetails';
import tcInvoiceDetail from '@/components/financeCenter/tcInvoiceDetail';
import tcSettlementContract from '@/components/financeCenter/tcSettlementContract';
import customerOrderList from '@/components/financeCenter/customerOrderList';
import supplierBalance from '@/components/financeCenter/supplierBalance';
import supplierQuickBalance from '@/components/financeCenter/supplierQuickBalance';
import supplierDayList from '@/components/financeCenter/supplierDayList';
import GYS_Evaluate from '@/components/financeCenter/GYS_Evaluate';
import gysInvoiceDetail from '@/components/financeCenter/gysInvoiceDetail';
import supplierOrderList from '@/components/financeCenter/supplierOrderList';
import invoicingLedger from '@/components/financeCenter/invoicingLedger';
import depositPurchase from '@/components/financeCenter/depositPurchase';
import totalDepositPurchase from '@/components/financeCenter/totalDepositPurchase';
import incomeReport from '@/components/financeCenter/incomeReport';
import financeCloseBill from '@/components/financeCenter/financeCloseBill';
import invoiceList from '@/components/financeCenter/invoiceList';
import invoiceForm from '@/components/financeCenter/invoiceForm';
import supplierCustomerOrderList from '@/components/financeCenter/supplierCustomerOrderList';
import supplierCustomerInvoiceDetails from '@/components/financeCenter/supplierCustomerInvoiceDetails';
import supplierCustomerOrderDayList from '@/components/financeCenter/supplierCustomerOrderDayList';

// 产品管理


// 设置
import setting from '@/components/setting/setting';
import generalSettings from '@/components/setting/generalSettings';
import templatePrint from '@/components/setting/templatePrint';
import allPrint from '@/components/setting/allPrint';


// 配送中心
import printPreview from '@/components/sendDocument/printPreview';
import salesOrderAudit from '@/components/sendDocument/salesOrderAudit';
import salesOrderAuditDetail from '@/components/sendDocument/salesOrderAuditDetail';
import s_distributionCenterOrderCheck from '@/components/shopOrderManage/s_distributionCenterOrderCheck';
import sortingDetailsPrint from '@/components/orderPrint/sortingDetailsPrint';
import sortingDetailsPrintTax from '@/components/orderPrint/sortingDetailsPrintTax';

// 供应商管理
import supplierManage from '@/components/supplierManage/supplierManage';
// 邀请供应商入驻界面
import settledSupplierRegister from '@/components/supplierManage/settledSupplierRegister';
// 自主入驻配置界面
import settledDisposition from '@/components/supplierManage/settledDisposition';
// 校验项管理界面
import qualificationItemManagement from '@/components/supplierManage/qualificationItemManagement';
// 匹配资质项界面
import matchQualifications from '@/components/supplierManage/matchQualifications';
import skuProducts from '@/components/supplierManage/skuProducts';
import addNewProduct from '@/components/supplierManage/addNewProduct';
import supplierLicense from '@/components/supplierManage/supplierLicense';
import uploadLicense from '@/components/supplierManage/uploadLicense';
import supplyCapacity from '@/components/supplierManage/supplyCapacity';

// 食品安全
import contractManage from '@/components/foodSecurity/contractManage';
import contractImage from '@/components/foodSecurity/contractImage';
import qualificatManage from '@/components/foodSecurity/qualificatManage'; // 资质上传
import qualificatDetail from '@/components/foodSecurity/qualificatDetail'; // 资质详情
import downloadQualificat from '@/components/foodSecurity/downloadQualificat'; // 采购品资质下载
import downloadQualificatDetail from '@/components/foodSecurity/downloadQualificatDetail'; // 采购品资质下载详情
import viewQualificatDetail from '@/components/foodSecurity/viewQualificatDetail'; // 采购品资质下载详情查看
import pesticideResidueDetection from '@/components/foodSecurity/pesticideResidueDetection'; // 农残检测
// import qualificationInspection from '@/components/foodSecurity/qualificationInspection' //资质检验
// 检测报告
import notCheckDoc from '@/components/foodSecurity/notCheckDoc';
import haveCheckDoc from '@/components/foodSecurity/haveCheckDoc';

// DS订单
import DSOrder from '@/components/DSOrder/DSOrder';
import DSOrderConfirmList from '@/components/DSOrder/DSOrderConfirmList';
import DSHistoryOrderList from '@/components/DSOrder/DSHistoryOrderList';
import DSOrdeInquiry from '@/components/DSOrder/DSOrdeInquiry';
import DSOrdeInquiryDetail from '@/components/DSOrder/DSOrdeInquiryDetail';
import DSOrderDetail from '@/components/DSOrder/DSOrderDetail';
import DSConfirmDetail from '@/components/DSOrder/DSConfirmDetail';
import DSHistoryDetail from '@/components/DSOrder/DSHistoryDetail';
import copyVirtualOrder from '@/components/sellOrderManage/copyVirtualOrder';
import sendingDocumentSupplier from '@/components/sortingAndDistribution/sendingDocumentSupplier';
import DSUnpriceOrderDetail from '@/components/DSOrder/DSUnpriceOrderDetail.vue';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: login,
    },
    {
      path: '/forget',
      name: 'forget',
      component: forget,
    },
    {
      path: '/loginEditPass',
      name: 'loginEditPass',
      component: loginEditPass,
    },
    {
      path: '/firstOrderPrint',
      name: 'firstOrderPrint',
      component: firstOrderPrint,
    },
    {
      path: '/selfOrderPrintBySequence',
      name: 'selfOrderPrintBySequence',
      component: selfOrderPrintBySequence,
    },
    {
      path: '/settledSupplierRegister/:id',
      name: 'settledSupplierRegister',
      component: settledSupplierRegister,
    },
    {
      path: '/preview',
      name: 'preview',
      component: preview,
    },
    {
      path: '/printPreviewCustom',
      name: 'printPreviewCustom',
      component: printPreviewCustom,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: '/s_orderPrint',
      name: 's_orderPrint',
      component: s_orderPrint,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: '/historyPrint',
      name: 'historyPrint',
      component: historyPrint,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: '/historyStorageShortPrint',
      name: 'historyStorageShortPrint',
      component: historyStorageShortPrint,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: '/pickingOutShortPrint',
      name: 'pickingOutShortPrint',
      component: pickingOutShortPrint,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: '/pickingOutShortPrintTax',
      name: 'pickingOutShortPrintTax',
      component: pickingOutShortPrintTax,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: '/s_historyPrint',
      name: 's_historyPrint',
      component: s_historyPrint,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: '/s_printTax',
      name: 's_printTax',
      component: s_printTax,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: '/s_pricePrint',
      name: 's_pricePrint',
      component: s_pricePrint,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: '/s_priceTax',
      name: 's_priceTax',
      component: s_priceTax,
      meta: {
        requireAuth: true,
      },
    },

    {
      path: '/shortOrderPrint',
      name: 'shortOrderPrint',
      component: shortOrderPrint,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: '/shortPrintTax',
      name: 'shortPrintTax',
      component: shortPrintTax,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: '/historyShortPrint',
      name: 'historyShortPrint',
      component: historyShortPrint,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: '/supplierCusOrderPrint',
      name: 'supplierCusOrderPrint',
      component: supplierCusOrderPrint,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: '/sellOrderPrint',
      name: 'sellOrderPrint',
      component: sellOrderPrint,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: '/sellOrderCustomPrintDetail',
      name: 'sellOrderCustomPrintDetail',
      component: sellOrderCustomPrintDetail,
      meta: {
        requireAuth: true,
      },
    },
    // 项目点日订单打印
    {
      path: '/dailyOrderPrinting',
      name: 'dailyOrderPrinting',
      component: dailyOrderPrinting,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: '/sellOrderSupplierPrintDetail',
      name: 'sellOrderSupplierPrintDetail',
      component: sellOrderSupplierPrintDetail,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: '/toBeConfirmePrintDetail',
      name: 'toBeConfirmePrintDetail',
      component: toBeConfirmePrintDetail,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: '/sellAllOrderPrint',
      name: 'sellAllOrderPrint',
      component: sellAllOrderPrint,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: '/sellOrderPrintSelf',
      name: 'sellOrderPrintSelf',
      component: sellOrderPrintSelf,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: '/sellOrderFivePrint',
      name: 'sellOrderFivePrint',
      component: sellOrderFivePrint,
      meta: {
        requireAuth: true,
      },
    },
    // 分拣明细打印预览
    {
      path: '/sortingDetailsPrint',
      name: 'sortingDetailsPrint',
      component: sortingDetailsPrint,
      meta: {
        requireAuth: true,
      },
    },
    // 分拣明细打印
    {
      path: '/sortingDetailsPrintTax',
      name: 'sortingDetailsPrintTax',
      component: sortingDetailsPrintTax,
      meta: {
        requireAuth: true,
      },
    },
    // 对标网站价格打印预览
    {
      path: '/websitePricePrint',
      name: 'websitePricePrint',
      component: websitePricePrint,
      meta: {
        requireAuth: true,
      },
    },
    // 对标网站价格打印
    {
      path: '/websitePricePrintTax',
      name: 'websitePricePrintTax',
      component: websitePricePrintTax,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: '/Public',
      name: 'Public',
      component: Public,
      children: [
        {
          path: '/welcome',
          name: 'welcome',
          component: welcome,
          meta: {
            requireAuth: true,
            title: '首页',
          },
        },
        // 打印标签
        {
          path: '/s_print',
          name: 's_print',
          component: s_print,
          meta: {
            requireAuth: true,
            title: '打印标签',
          },
        },
        // 分拣差异查询
        {
          path: '/sortingVarianceQuery',
          name: 'sortingVarianceQuery',
          component: sortingVarianceQuery,
          meta: {
            requireAuth: true,
            title: '分拣差异查询',
          },
        },
        // 采购报表
        {
          path: '/purchase',
          name: 'purchase',
          component: purchase,
          meta: {
            requireAuth: true,
            title: '采购报表',
          },
        },
        // 销售报表
        {
          path: '/salesStatements',
          name: 'salesStatements',
          component: salesStatements,
          meta: {
            requireAuth: true,
            title: '销售报表',
          },
        },
        // 毛利表
        {
          path: '/grossProfit',
          name: 'grossProfit',
          component: grossProfit,
          meta: {
            requireAuth: true,
            title: '毛利报表',
          },
        },
        {
          path: '/s_contantract/:id',
          name: 's_contantract',
          component: s_contantract,
          meta: {
            requireAuth: true,
            title: '订单资质',
            breadNumber: 4,
          },
        },
        {
          path: '/s_historyContantract',
          name: 's_historyContantract',
          component: s_historyContantract,
          meta: {
            requireAuth: true,
            title: '订单资质',
            breadNumber: 2,
          },
        },
        // 财务中心-进销存台账
        {
          path: '/invoicingLedger',
          name: 'invoicingLedger',
          component: invoicingLedger,
          meta: {
            requireAuth: true,
            title: '进销存台账',
          },
        },
        // 进销存
        {
          path: '/depositPurchase',
          name: 'depositPurchase',
          component: depositPurchase,
          meta: {
            requireAuth: true,
            title: '进销存台账',
          },
        },
        // 报价
        {
          path: '/quote',
          name: 'quote',
          component: quote,
          meta: {
            requireAuth: true,
            title: '周期性报价',
          },
        },
        // 快捷销售定价
        {
          path: '/expressSalePricing',
          name: 'expressSalePricing',
          component: expressSalePricing,
          meta: {
            requireAuth: true,
            title: '快捷销售定价',
          },
        },
        // 周期性报价
        {
          path: '/periodicQuotation',
          name: 'periodicQuotation',
          component: periodicQuotation,
          meta: {
            requireAuth: true,
            title: '周期性报价',
          },
        },
        {
          path: '/quoteDetails',
          name: 'quoteDetails',
          component: quoteDetails,
          meta: {
            requireAuth: true,
            title: '报价详情',
            breadNumber: 2,
          },
        },
        {
          path: '/viewPrice',
          name: 'viewPrice',
          component: viewPrice,
          meta: {
            requireAuth: true,
            title: '当期报价',
            breadNumber: 2,
          },
        },
        {
          path: '/supplierProduct/:submitId',
          name: 'supplierProduct',
          component: supplierProduct,
          meta: {
            requireAuth: true,
            title: '新增报价',
            breadNumber: 2,
          },
        },
        {
          path: '/SubmitPrice',
          name: 'SubmitPrice',
          component: SubmitPrice,
          meta: {
            requireAuth: true,
            title: '新增报价',
            breadNumber: 2,
          },
        },
        {
          path: '/purchaseQuotation',
          name: 'purchaseQuotation',
          component: purchaseQuotation,
          meta: {
            requireAuth: true,
            title: '供应商报价记录',
          },
        },
        // 延时审核
        {
          path: '/delayedReview',
          name: 'delayedReview',
          component: delayedReview,
          meta: {
            requireAuth: true,
            title: '订单延时审核列表',
          },
        },
        // 退货审核
        {
          path: '/returnAudit',
          name: 'returnAudit',
          component: returnAudit,
          meta: {
            requireAuth: true,
            title: '退货审核',
          },
        },
        // 销售订单管理
        {
          path: '/entryOrderList',
          name: 'entryOrderList',
          component: entryOrderList,
          meta: {
            requireAuth: true,
            title: '录入订单',
          },
        },
        {
          path: '/copyVirtualOrder',
          name: 'copyVirtualOrder',
          component: copyVirtualOrder,
          meta: {
            requireAuth: true,
            title: '复制虚拟订单',
            breadNumber: 2,
          },
        },

        // 补单
        {
          path: '/SupplementOrder',
          name: 'SupplementOrder',
          component: SupplementOrder,
          meta: {
            requireAuth: true,
            title: '补单',
          },
        },
        {
          path: '/qualificatManage',
          name: 'qualificatManage',
          component: qualificatManage,
          meta: {
            requireAuth: true,
            title: '资质上传',
          },
        },
        {
          path: '/qualificatDetail',
          name: 'qualificatDetail',
          component: qualificatDetail,
          meta: {
            requireAuth: true,
            title: '资质详情',
            breadNumber: 2,
          },
        },
        {
          path: '/downloadQualificat',
          name: 'downloadQualificat',
          component: downloadQualificat,
          meta: {
            requireAuth: true,
            title: '采购品资质下载',
          },
        },
        {
          path: '/downloadQualificatDetail/:detail',
          name: 'downloadQualificatDetail',
          component: downloadQualificatDetail,
          meta: {
            requireAuth: true,
            title: '采购品资质下载详情',
            breadNumber: 2,
          },
        },
        {
          path: '/viewQualificatDetail',
          name: 'viewQualificatDetail',
          component: viewQualificatDetail,
          meta: {
            requireAuth: true,
            title: '采购品资质查看',
            breadNumber: 3,
          },
        },
        {
          path: '/addOrder/:detail',
          name: 'addOrder',
          component: addOrder,
          meta: {
            requireAuth: true,
            title: '手动录入',
            breadNumber: 2,
          },
        },
        {
          path: '/addProduct',
          name: 'addProduct',
          component: addProduct,
          meta: {
            requireAuth: true,
            title: '新增产品',
            breadNumber: 3,
          },
        },
        {
          path: '/NewOrderList',
          name: 'NewOrderList',
          component: NewOrderList,
          meta: {
            requireAuth: true,
            title: '待送订单列表(销售)',
          },
        },
        {
          path: '/sellOrderCustomPrint',
          name: 'sellOrderCustomPrint',
          component: sellOrderCustomPrint,
          meta: {
            requireAuth: true,
            title: '自定义打印',
          },
        },

        {
          path: '/newOrderDetail/:detail',
          name: 'newOrderDetail',
          component: newOrderDetail,
          meta: {
            requireAuth: true,
            title: '订单详情',
            breadNumber: 2,
          },
        },
        {
          path: '/OrderConfirmList',
          name: 'OrderConfirmList',
          component: OrderConfirmList,
          meta: {
            requireAuth: true,
            title: '待确认订单列表(销售)',
          },
        },
        {
          path: '/confirmOrderDetail/:detail',
          name: 'confirmOrderDetail',
          component: confirmOrderDetail,
          meta: {
            requireAuth: true,
            title: '订单详情',
            breadNumber: 2,
          },
        },

        {
          path: '/selfOrderCheck/:detail',
          name: 'selfOrderCheck',
          component: selfOrderCheck,
          meta: {
            requireAuth: true,
            title: '修改',
            breadNumber: 2,
          },
        },
        {
          path: '/HistoryOrderList',
          name: 'HistoryOrderList',
          component: HistoryOrderList,
          meta: {
            requireAuth: true,
            title: '历史订单列表(销售)',
          },
        },
        {
          path: '/historyOrderDetail/:detail',
          name: 'historyOrderDetail',
          component: historyOrderDetail,
          meta: {
            requireAuth: true,
            title: '订单详情',
            breadNumber: 2,
          },
        },
        {
          path: '/complementOutWarehouse',
          name: 'complementOutWarehouse',
          component: complementOutWarehouse,
          meta: {
            requireAuth: true,
            title: '补出库',
            breadNumber: 3,
          },
        },
        {
          path: '/orderContract/:id',
          name: 'orderContract',
          component: orderContract,
          meta: {
            requireAuth: true,
            title: '订单资质',
            breadNumber: 2,
          },
        },
        // 采购订单管理-手动录入
        {
          path: '/s_addOrder/:detail',
          name: 's_addOrder',
          component: s_addOrder,
          meta: {
            requireAuth: true,
            title: '手动录入',
            breadNumber: 2,
          },
        },
        // 采购订单管理-手动录入-批量添加
        {
          path: '/s_batchAddOrder/:orderId',
          name: 's_batchAddOrder',
          component: s_batchAddOrder,
          meta: {
            requireAuth: true,
            title: '手动录入',
            breadNumber: 3,
          },
        },
        {
          path: '/s_orderCheck/:detail',
          name: 's_orderCheck',
          component: s_orderCheck,
          meta: {
            requireAuth: true,
            title: '验收',
            breadNumber: 2,
          },
        },
        {
          path: '/s_addProduct',
          name: 's_addProduct',
          component: s_addProduct,
          meta: {
            requireAuth: true,
            title: '新增产品',
            breadNumber: 3,
          },
        },
        {
          path: '/s_NewOrderList',
          name: 's_NewOrderList',
          component: s_NewOrderList,
          meta: {
            requireAuth: true,
            title: '待送订单',
          },
        },
        {
          path: '/remarksReview',
          name: 'remarksReview',
          component: remarksReview,
          meta: {
            requireAuth: true,
            title: '备注审核',
          },
        },
        {
          path: '/s_HistoryOrderList',
          name: 's_HistoryOrderList',
          component: s_HistoryOrderList,
          meta: {
            requireAuth: true,
            title: '历史订单列表',
          },
        },
        {
          path: '/s_OrderDetail/:detail',
          name: 's_OrderDetail',
          component: s_OrderDetail,
          meta: {
            requireAuth: true,
            title: '订单详情',
            breadNumber: 2,
          },
        },
        // 配送单管理
        {
          path: '/sendingDocument',
          name: 'sendingDocument',
          component: sendingDocument,
          meta: {
            requireAuth: true,
            title: '配送单管理',
          },
        },
        {
          path: '/purchaseOrder',
          name: 'purchaseOrder',
          component: purchaseOrder,
          meta: {
            requireAuth: true,
            title: '销售转采购',
          },
        },
        {
          path: '/PurchaseMatchProduct',
          name: 'PurchaseMatchProduct',
          component: PurchaseMatchProduct,
          meta: {
            requireAuth: true,
            title: '匹配产品',
            breadNumber: 3,
          },
        },
        // 客户管理
        {
          path: '/customerList',
          name: 'customerList',
          component: customerList,
          meta: {
            requireAuth: true,
            title: '客户列表',
          },
        },
        // 收入上报
        {
          path: '/incomeReport',
          name: 'incomeReport',
          component: incomeReport,
          meta: {
            requireAuth: true,
            title: '收入上报',
          },
        },
        {
          path: '/projectList/:detail',
          name: 'projectList',
          component: projectList,
          meta: {
            requireAuth: true,
            title: '项目点列表',
            breadNumber: 2,
          },
        },
        {
          path: '/dkList',
          name: 'dkList',
          component: dkList,
          meta: {
            requireAuth: true,
            title: '档口列表',
            breadNumber: 3,
          },
        },
        {
          path: '/queryProducts/:detail',
          name: 'queryProducts',
          component: queryProducts,
          meta: {
            requireAuth: true,
            title: '商品管理',
            breadNumber: 2,
          },
        },
        {
          path: '/addProductsList',
          name: 'addProductsList',
          component: addProductsList,
          meta: {
            requireAuth: true,
            title: '产品上架',
            breadNumber: 3,
          },
        },
        // 成本中心
        {
          path: '/sellPrice',
          name: 'sellPrice',
          component: sellPrice,
          meta: {
            requireAuth: true,
            title: '售价管理',
          },
        },
        {
          path: '/soldPriceDetail',
          name: 'soldPriceDetail',
          component: soldPriceDetail,
          meta: {
            requireAuth: true,
            title: '填写售价',
            breadNumber: 2,
          },
        },
        {
          path: '/orderList',
          name: 'orderList',
          component: orderList,
          meta: {
            requireAuth: true,
            title: '订单列表',
          },
        },
        {
          path: '/orderProfitDetail',
          name: 'orderProfitDetail',
          component: orderProfitDetail,
          meta: {
            requireAuth: true,
            title: '订单详情',
            breadNumber: 2,
          },
        },
        {
          path: '/shopPrice',
          name: 'shopPrice',
          component: shopPrice,
          meta: {
            requireAuth: true,
            title: '采购价管理',
          },
        },
        // 通用设置
        {
          path: '/generalSettings',
          name: 'generalSettings',
          component: generalSettings,
          meta: {
            requireAuth: true,
            title: '通用设置',
          },
        },
        {
          path: '/skuProducts/:detail',
          name: 'skuProducts',
          component: skuProducts,
          meta: {
            requireAuth: true,
            title: '产品管理',
            breadNumber: 2,
          },
        },
        {
          path: '/addNewProduct',
          name: 'addNewProduct',
          component: addNewProduct,
          meta: {
            requireAuth: true,
            title: '新增产品',
            breadNumber: 3,
          },
        },
        {
          path: '/matchProduct',
          name: 'matchProduct',
          component: matchProduct,
          meta: {
            requireAuth: true,
            title: '匹配产品',
            breadNumber: 3,
          },
        },
        {
          path: '/lineSet',
          name: 'lineSet',
          component: lineSet,
          meta: {
            requireAuth: true,
            title: '线路配置',
          },
        },
        {
          path: '/carSet',
          name: 'carSet',
          component: carSet,
          meta: {
            requireAuth: true,
            title: '车辆管理',
          },
        },
        {
          path: '/categoryCost/:detail',
          name: 'categoryCost',
          component: categoryCost,
          meta: {
            requireAuth: true,
            title: '费用大类',
            breadNumber: 2,
          },
        },
        {
          path: '/costSecondType/:detail',
          name: 'costSecondType',
          component: costSecondType,
          meta: {
            requireAuth: true,
            title: '费用二类',
            breadNumber: 3,
          },
        },
        {
          path: '/accountManagement/:id',
          name: 'accountManagement',
          component: accountManagement,
          meta: {
            requireAuth: true,
            title: '账号管理',
            breadNumber: 2,
          },
        },
        {
          path: '/matchCar/:id',
          name: 'matchCar',
          component: matchCar,
          meta: {
            requireAuth: true,
            title: '匹配车辆',
            breadNumber: 2,
          },
        },
        {
          path: '/monitor',
          name: 'monitor',
          component: monitor,
          meta: {
            requireAuth: true,
            title: '物流监控',
          },
        },
        {
          path: '/deliveryTaskProgress',
          name: 'deliveryTaskProgress',
          component: deliveryTaskProgress,
          meta: {
            requireAuth: true,
            title: '配送任务进度',
          },
        },
        {
          path: '/allPrint',
          name: 'allPrint',
          component: allPrint,
          meta: {
            requireAuth: true,
            title: '打印设置信息',
            breadNumber: 2,
          },
        },
        {
          path: '/templatePrint',
          name: 'templatePrint',
          component: templatePrint,
          meta: {
            requireAuth: true,
            title: '打印设置',
          },
        },
        {
          path: '/lineSetDetail/:id',
          name: 'lineSetDetail',
          component: lineSetDetail,
          meta: {
            requireAuth: true,
            title: '匹配的项目点',
            breadNumber: 2,
          },
        },
        {
          path: '/supplierManage',
          name: 'supplierManage',
          component: supplierManage,
          meta: {
            requireAuth: true,
            title: '供应商列表',
          },
        },
        {
          path: '/settledDisposition',
          name: 'settledDisposition',
          component: settledDisposition,
          meta: {
            requireAuth: true,
            title: '入驻配置',
            breadNumber: 2,
          },
        },
        {
          path: '/qualificationItemManagement',
          name: 'qualificationItemManagement',
          component: qualificationItemManagement,
          meta: {
            requireAuth: true,
            title: '资质项管理',
            breadNumber: 3,
          },
        },
        {
          path: '/matchQualifications/:id/:gysId',
          name: 'matchQualifications',
          component: matchQualifications,
          meta: {
            requireAuth: true,
            title: '匹配资质项',
            breadNumber: 3,
          },
        },
        {
          path: '/groupManage',
          name: 'groupManage',
          component: groupManage,
          meta: {
            requireAuth: true,
            title: '分组管理',
          },
        },
        {
          path: '/matchGroup',
          name: 'matchGroup',
          component: matchGroup,
          meta: {
            requireAuth: true,
            title: '匹配档口',
            breadNumber: 2,
          },
        },
        {
          path: '/matchDK',
          name: 'matchDK',
          component: matchDK,
          meta: {
            requireAuth: true,
            title: '档口列表',
            breadNumber: 3,
          },
        },
        {
          path: '/contractManage',
          name: 'contractManage',
          component: contractManage,
          meta: {
            requireAuth: true,
            title: '资质管理',
          },
        },
        {
          path: '/contractImage',
          name: 'contractImage',
          component: contractImage,
          meta: {
            requireAuth: true,
            title: '资质凭证',
            breadNumber: 2,
          },
        },
        {
          path: '/stockOutNoDetail',
          name: 'stockOutNoDetail',
          component: stockOutNoDetail,
          meta: {
            requireAuth: true,
            title: '库存不足产品',
            breadNumber: 2,
          },
        },
        {
          path: '/ckaddProduct',
          name: 'ckaddProduct',
          component: ckaddProduct,
          meta: {
            requireAuth: true,
            title: '新增产品',
            breadNumber: 3,
          },
        },
        {
          path: '/returnOutDetail',
          name: 'returnOutDetail',
          component: returnOutDetail,
          meta: {
            requireAuth: true,
            title: '退货出库详情',
            breadNumber: 2,
          },
        },
        {
          path: '/haveCheck',
          name: 'haveCheck',
          component: haveCheck,
          meta: {
            requireAuth: true,
            title: '仓库已审批列表',
          },
        },
        {
          path: '/returnOutStock',
          name: 'returnOutStock',
          component: returnOutStock,
          meta: {
            requireAuth: true,
            title: '退货出库',
          },
        },
        {
          path: '/GYSHaveCheck',
          name: 'GYSHaveCheck',
          component: GYSHaveCheck,
          meta: {
            requireAuth: true,
            title: '供应商已审批列表',
          },
        },
        {
          path: '/checkDetail/:detail',
          name: 'checkDetail',
          component: checkDetail,
          meta: {
            requireAuth: true,
            title: '退货凭证',
            breadNumber: 2,
          },
        },
        {
          path: '/haveCheckDetail',
          name: 'haveCheckDetail',
          component: haveCheckDetail,
          meta: {
            requireAuth: true,
            title: '退货凭证',
            breadNumber: 2,
          },
        },
        // 结算管理
        {
          path: '/tcBalance',
          name: 'tcBalance',
          component: tcBalance,
          meta: {
            requireAuth: true,
            title: '团餐公司结算',
          },
        },
        {
          path: '/supplierBalance',
          name: 'supplierBalance',
          component: supplierBalance,
          meta: {
            requireAuth: true,
            title: '供应商结算',
          },
        },
        {
          path: '/supplierQuickBalance',
          name: 'supplierQuickBalance',
          component: supplierQuickBalance,
          meta: {
            requireAuth: true,
            title: '供应商快捷结算',
          },
        },
        {
          path: '/costReport',
          name: 'costReport',
          component: costReport,
          meta: {
            requireAuth: true,
            title: '费用上报',
          },
        },
        {
          path: 'settlementOrderContract/:detail',
          name: 'settlementOrderContract',
          component: settlementOrderContract,
          meta: {
            requireAuth: true,
            title: '订单资质',
            breadNumber: 3,
          },
        },
        {
          path: 'tcBillingDetails',
          name: 'tcBillingDetails',
          component: tcBillingDetails,
          meta: {
            requireAuth: true,
            title: '结算明细',
            breadNumber: 2,
          },
        },
        {
          path: 'tcInvoiceDetail',
          name: 'tcInvoiceDetail',
          component: tcInvoiceDetail,
          meta: {
            requireAuth: true,
            title: '开票明细',
            breadNumber: 3,
          },
        },
        {
          path: 'gysInvoiceDetail',
          name: 'gysInvoiceDetail',
          component: gysInvoiceDetail,
          meta: {
            requireAuth: true,
            title: '开票明细',
            breadNumber: 2,
          },
        },
        {
          path: 'tcSettlementContract',
          name: 'tcSettlementContract',
          component: tcSettlementContract,
          meta: {
            requireAuth: true,
            title: '订单资质',
            breadNumber: 3,
          },
        },
        {
          path: '/customerBalance',
          name: 'customerBalance',
          component: customerBalance,
          meta: {
            requireAuth: true,
            title: '自录客户结算',
          },
        },
        {
          path: '/customerOrderDayList/:detail',
          name: 'customerOrderDayList',
          component: customerOrderDayList,
          meta: {
            requireAuth: true,
            title: '订单详情',
            breadNumber: 3,
          },
        },
        {
          path: '/tcOrderList/:detail',
          name: 'tcOrderList',
          component: tcOrderList,
          meta: {
            requireAuth: true,
            title: '结算列表',
            breadNumber: 2,
          },
        },
        {
          path: '/invoiceDetail',
          name: 'invoiceDetail',
          component: invoiceDetail,
          meta: {
            requireAuth: true,
            title: '开票明细',
            breadNumber: 2,
          },
        },
        {
          path: '/tcBalanceDayList/:detail',
          name: 'tcBalanceDayList',
          component: tcBalanceDayList,
          meta: {
            requireAuth: true,
            title: '订单详情',
            breadNumber: 3,
          },
        },
        {
          path: '/customerDetail/:id/:month',
          name: 'customerDetail',
          component: customerDetail,
          meta: {
            requireAuth: true,
            title: '结算统计',
            breadNumber: 2,
          },
        },
        {
          path: '/GYS_Evaluate/:detail',
          name: 'GYS_Evaluate',
          component: GYS_Evaluate,
          meta: {
            requireAuth: true,
            title: '供应商评价',
            breadNumber: 2,
          },
        },
        {
          path: '/billingDetails',
          name: 'billingDetails',
          component: billingDetails,
          meta: {
            requireAuth: true,
            title: '结算明细',
            breadNumber: 2,
          },
        },
        {
          path: '/supplierOrderList/:detail',
          name: 'supplierOrderList',
          component: supplierOrderList,
          meta: {
            requireAuth: true,
            title: '订单结算列表',
            breadNumber: 2,
          },
        },
        {
          path: '/supplierDayList/:detail',
          name: 'supplierDayList',
          component: supplierDayList,
          meta: {
            requireAuth: true,
            title: '订单详情',
            breadNumber: 3,
          },
        },
        {
          path: '/customerOrderList/:detail',
          name: 'customerOrderList',
          component: customerOrderList,
          meta: {
            requireAuth: true,
            title: '结算列表',
            breadNumber: 2,
          },
        },
        // 报表
        {
          path: '/profitLossTable',
          name: 'profitLossTable',
          component: profitLossTable,
          meta: {
            requireAuth: true,
            title: '盘库盈亏表',
          },
        },
        {
          path: '/historyInStock',
          name: 'historyInStock',
          component: historyInStock,
          meta: {
            requireAuth: true,
            title: '历史入库单',
          },
        },
        {
          path: '/historyInDetail/:detail',
          name: 'historyInDetail',
          component: historyInDetail,
          meta: {
            requireAuth: true,
            title: '历史入库单详情',
            breadNumber: 2,
          },
        },
        // 仓库管理
        {
          path: '/stockList',
          name: 'stockList',
          component: stockList,
          meta: {
            requireAuth: true,
            title: '库存',
          },
        },
        {
          path: '/stockDetail/:detail',
          name: 'stockDetail',
          component: stockDetail,
          meta: {
            requireAuth: true,
            title: '库存详情',
            breadNumber: 2,
          },
        },
        {
          path: '/stockOut',
          name: 'stockOut',
          component: stockOut,
          meta: {
            requireAuth: true,
            title: '出库',
          },
        },
        {
          path: '/plannedOutbound',
          name: 'plannedOutbound',
          component: plannedOutbound,
          meta: {
            requireAuth: true,
            title: '拟出库情况',
          },
        },
        {
          path: '/noDocumentMatching/:detail',
          name: 'noDocumentMatching',
          component: noDocumentMatching,
          meta: {
            requireAuth: true,
            title: '无单据匹配出库',
            breadNumber: 2,
          },
        },
        {
          path: '/matchDocument',
          name: 'matchDocument',
          component: matchDocument,
          meta: {
            requireAuth: true,
            title: '匹配确认',
            breadNumber: 2,
          },
        },
        {
          path: '/stockEnter',
          name: 'stockEnter',
          component: stockEnter,
          meta: {
            requireAuth: true,
            title: '入库',
          },
        },
        {
          path: '/checkStock',
          name: 'checkStock',
          component: checkStock,
          meta: {
            requireAuth: true,
            title: '盘库',
          },
        },
        {
          path: '/historyOut',
          name: 'historyOut',
          component: historyOut,
          meta: {
            requireAuth: true,
            title: '历史出库单',
          },
        },
        {
          path: '/batchReturnOfInventory',
          name: 'batchReturnOfInventory',
          component: batchReturnOfInventory,
          meta: {
            requireAuth: true,
            title: '批量退库',
            breadNumber: 2,
          },
        },

        {
          path: '/singleSalesSummary',
          name: 'singleSalesSummary',
          component: singleSalesSummary,
          meta: {
            requireAuth: true,
            title: '项目单品销售汇总',
          },
        },
        {
          path: '/itemSalesSchedule',
          name: 'itemSalesSchedule',
          component: itemSalesSchedule,
          meta: {
            requireAuth: true,
            title: '项目单品销售明细表',
          },
        },
        {
          path: '/SupplierPurchaseSchedule',
          name: 'SupplierPurchaseSchedule',
          component: SupplierPurchaseSchedule,
          meta: {
            requireAuth: true,
            title: '供应商单品采购明细表',
          },
        },
        {
          path: '/projectPointGrossProfitTable',
          name: 'projectPointGrossProfitTable',
          component: projectPointGrossProfitTable,
          meta: {
            requireAuth: true,
            title: '项目点毛利表',
          },
        },
        {
          path: '/historyDetail/:detail',
          name: 'historyDetail',
          component: historyDetail,
          meta: {
            requireAuth: true,
            title: '历史出库单详情',
            breadNumber: 2,
          },
        },
        // 历史出库单增加补出库
        // {
        //   path: '/ckaddProductRepair',
        //   name: 'ckaddProductRepair',
        //   component: ckaddProductRepair,
        //   meta: {
        //       requireAuth: true
        //   }
        // },
        {
          path: '/stockOutDetail/:detail',
          name: 'stockOutDetail',
          component: stockOutDetail,
          meta: {
            requireAuth: true,
            title: '出库详情',
            breadNumber: 2,
          },
        },
        {
          path: '/stockEnterDetail/:detail',
          name: 'stockEnterDetail',
          component: stockEnterDetail,
          meta: {
            requireAuth: true,
            title: '入库详情',
            breadNumber: 2,
          },
        },
        {
          path: '/createStock',
          name: 'createStock',
          component: createStock,
          meta: {
            requireAuth: true,
            title: '创建盘库单',
            breadNumber: 2,
          },
        },
        {
          path: '/entryStock/:status',
          name: 'entryStock',
          component: entryStock,
          meta: {
            requireAuth: true,
            title: '录入盘库数据',
            breadNumber: 3,
          },
        },
        {
          path: '/stockListDetail/:detail',
          name: 'stockListDetail',
          component: stockListDetail,
          meta: {
            requireAuth: true,
            title: '库存流水',
            breadNumber: 2,
          },
        },
        {
          path: '/returnWarehouse',
          name: 'returnWarehouse',
          component: returnWarehouse,
          meta: {
            requireAuth: true,
            title: '销售退库单',
          },
        },
        {
          path: '/returnWareDetail/:detail',
          name: 'returnWareDetail',
          component: returnWareDetail,
          meta: {
            requireAuth: true,
            title: '销售退库单详情',
            breadNumber: 2,
          },
        },
        {
          path: '/returnProduct',
          name: 'returnProduct',
          component: returnProduct,
          meta: {
            requireAuth: true,
            title: '采购退货单',
          },
        },
        {
          path: '/returnProductDetail/:detail',
          name: 'returnProductDetail',
          component: returnProductDetail,
          meta: {
            requireAuth: true,
            title: '退货单详情',
            breadNumber: 2,
          },
        },
        {
          path: '/pickingProduct',
          name: 'pickingProduct',
          component: pickingProduct,
          meta: {
            requireAuth: true,
            title: '领料出库',
            breadNumber: 2,
          },
        },
        {
          path: '/pickingShopCar',
          name: 'pickingShopCar',
          component: pickingShopCar,
          meta: {
            requireAuth: true,
            title: '领料购物车',
            breadNumber: 3,
          },
        },
        {
          path: '/pickingDoc',
          name: 'pickingDoc',
          component: pickingDoc,
          meta: {
            requireAuth: true,
            title: '领料单列表',
          },
        },
        {
          path: '/pickingDocDetail/:detail',
          name: 'pickingDocDetail',
          component: pickingDocDetail,
          meta: {
            requireAuth: true,
            title: '领料单详情',
            breadNumber: 2,
          },
        },
        {
          path: '/departmentManage',
          name: 'departmentManage',
          component: departmentManage,
          meta: {
            requireAuth: true,
            title: '领料部门管理',
            breadNumber: 2,
          },
        },
        {
          path: '/kindManage',
          name: 'kindManage',
          component: kindManage,
          meta: {
            requireAuth: true,
            title: '分类管理',
          },
        },
        {
          path: '/kindProduct/:detail',
          name: 'kindProduct',
          component: kindProduct,
          meta: {
            requireAuth: true,
            title: '产品管理',
            breadNumber: 2,
          },
        },
        {
          path: '/specialOut',
          name: 'specialOut',
          component: specialOut,
          meta: {
            requireAuth: true,
            title: '特殊出库产品',
          },
        },
        {
          path: '/productTax',
          name: 'productTax',
          component: productTax,
          meta: {
            requireAuth: true,
            title: '产品税率',
          },
        },
        {
          path: '/productApplication',
          name: 'productApplication',
          component: productApplication,
          meta: {
            requireAuth: true,
            title: '新品申请上架',
          },
        },
        {
          path: '/supplierTax',
          name: 'supplierTax',
          component: supplierTax,
          meta: {
            requireAuth: true,
            title: '供应商税率设置',
          },
        },
        {
          path: '/kindTax',
          name: 'kindTax',
          component: kindTax,
          meta: {
            requireAuth: true,
            title: '分类税率设置',
          },
        },
        {
          path: '/productStockingPlan',
          name: 'productStockingPlan',
          component: productStockingPlan,
          meta: {
            requireAuth: true,
            title: '产品备货方案',
          },
        },
        {
          path: '/unpackInfo',
          name: 'unpackInfo',
          component: unpackInfo,
          meta: {
            requireAuth: true,
            title: '拆箱查询',
          },
        },
        {
          path: '/productManage_supplier/:tid/:cid/:sid',
          name: 'productManage_supplier',
          component: productManage_supplier,
          meta: {
            requireAuth: true,
            title: '产品管理',
            breadNumber: 2,
          },
        },
        {
          path: '/productManage_kind/:tid/:cid',
          name: 'productManage_kind',
          component: productManage_kind,
          meta: {
            requireAuth: true,
            title: '产品管理',
            breadNumber: 2,
          },
        },
        {
          path: '/canInput',
          name: 'canInput',
          component: canInput,
          meta: {
            requireAuth: true,
            title: '可入库产品',
          },
        },
        {
          path: '/addKindProduct',
          name: 'addKindProduct',
          component: addKindProduct,
          meta: {
            requireAuth: true,
            title: '新增产品',
            breadNumber: 3,
          },
        },
        {
          path: '/totalPurchase',
          name: 'totalPurchase',
          component: totalPurchase,
          meta: {
            requireAuth: true,
            title: '采购汇总',
            breadNumber: 2,
          },
        },
        {
          path: '/detailPurchase',
          name: 'detailPurchase',
          component: detailPurchase,
          meta: {
            requireAuth: true,
            title: '采购明细',
            breadNumber: 2,
          },
        },
        {
          path: '/productMatch',
          name: 'productMatch',
          component: productMatch,
          meta: {
            requireAuth: true,
            title: '匹配产品',
            breadNumber: 3,
          },
        },
        {
          path: '/productionSet',
          name: 'productionSet',
          component: productionSet,
          meta: {
            requireAuth: true,
            title: 'BOM管理',
          },
        },
        {
          path: '/addProduction',
          name: 'addProduction',
          component: addProduction,
          meta: {
            requireAuth: true,
            title: '新增原材料',
            breadNumber: 2,
          },
        },
        {
          path: '/productionDetail',
          name: 'productionDetail',
          component: productionDetail,
          meta: {
            requireAuth: true,
            title: '生产配置',
            breadNumber: 2,
          },
        },
        {
          path: '/addProductionDetail',
          name: 'addProductionDetail',
          component: addProductionDetail,
          meta: {
            requireAuth: true,
            title: '新增配置',
            breadNumber: 3,
          },
        },
        {
          path: '/notCheckDoc',
          name: 'notCheckDoc',
          component: notCheckDoc,
          meta: {
            requireAuth: true,
            title: '未检测',
          },
        },
        {
          path: '/haveCheckDoc',
          name: 'haveCheckDoc',
          component: haveCheckDoc,
          meta: {
            requireAuth: true,
            title: '已检测',
          },
        },
        {
          path: '/clearing/:detail',
          name: 'clearing',
          component: clearing,
          meta: {
            requireAuth: true,
            title: '消洗保洁',
            breadNumber: 2,
          },
        },
        {
          path: '/clearingDetail',
          name: 'clearingDetail',
          component: clearingDetail,
          meta: {
            requireAuth: true,
            title: '消洗记录',
          },
        },
        {
          path: '/clearingCheck/:DM_ID',
          name: 'clearingCheck',
          component: clearingCheck,
          meta: {
            requireAuth: true,
            title: '参数详情',
            breadNumber: 3,
          },
        },
        {
          path: '/clearingArea/:detail',
          name: 'clearingArea',
          component: clearingArea,
          meta: {
            requireAuth: true,
            title: '区域管理',
            breadNumber: 2,
          },
        },
        {
          path: '/clearingParameter/:detail',
          name: 'clearingParameter',
          component: clearingParameter,
          meta: {
            requireAuth: true,
            title: '消毒参数',
            breadNumber: 2,
          },
        },
        {
          path: '/proPickingProduct',
          name: 'proPickingProduct',
          component: proPickingProduct,
          meta: {
            requireAuth: true,
            title: '生产领料',
            breadNumber: 2,
          },
        },
        {
          path: '/proPickingShopCar',
          name: 'proPickingShopCar',
          component: proPickingShopCar,
          meta: {
            requireAuth: true,
            title: '领料购物车',
            breadNumber: 3,
          },
        },
        {
          path: '/proPickingDoc',
          name: 'proPickingDoc',
          component: proPickingDoc,
          meta: {
            requireAuth: true,
            title: '生产领料单',
          },
        },
        {
          path: '/purchaseProduct',
          name: 'purchaseProduct',
          component: purchaseProduct,
          meta: {
            requireAuth: true,
            title: '销售转生产领料',
            breadNumber: 2,
          },
        },
        {
          path: '/addDish',
          name: 'addDish',
          component: addDish,
          meta: {
            requireAuth: true,
            title: '新增成品菜',
            breadNumber: 2,
          },
        },
        {
          path: '/addIngredients',
          name: 'addIngredients',
          component: addIngredients,
          meta: {
            requireAuth: true,
            title: '添加配料',
            breadNumber: 3,
          },
        },
        {
          path: '/ingredientsDetail',
          name: 'ingredientsDetail',
          component: ingredientsDetail,
          meta: {
            requireAuth: true,
            title: '配料表',
            breadNumber: 2,
          },
        },
        {
          path: '/dishManagement',
          name: 'dishManagement',
          component: dishManagement,
          meta: {
            requireAuth: true,
            title: '菜品BOM管理',
          },
        },
        {
          path: '/proWarehousing/',
          name: 'proWarehousing',
          component: proWarehousing,
          meta: {
            requireAuth: true,
            title: '生产入库',
          },
        },
        {
          path: '/proWarehousingDetails/:department',
          name: 'proWarehousingDetails',
          component: proWarehousingDetails,
          meta: {
            requireAuth: true,
            title: '生产入库详情',
            breadNumber: 2,
          },
        },
        {
          path: '/proManualWarehousing/:department',
          name: 'proManualWarehousing',
          component: proManualWarehousing,
          meta: {
            requireAuth: true,
            title: '手动入库',
            breadNumber: 2,
          },
        },
        {
          path: '/proReceipt',
          name: 'proReceipt',
          component: proReceipt,
          meta: {
            requireAuth: true,
            title: '生产入库单',
          },
        },
        {
          path: '/proReceiptDetails/:department',
          name: 'proReceiptDetails',
          component: proReceiptDetails,
          meta: {
            requireAuth: true,
            title: '生产入库单详情',
            breadNumber: 2,
          },
        },
        {
          path: '/proPickingDocDetail/:detail',
          name: 'proPickingDocDetail',
          component: proPickingDocDetail,
          meta: {
            requireAuth: true,
            title: '领料单详情',
            breadNumber: 2,
          },
        },
        {
          path: '/proPickingResult',
          name: 'proPickingResult',
          component: proPickingResult,
          meta: {
            requireAuth: true,
            title: '生产详情',
            breadNumber: 3,
          },
        },
        {
          path: '/totalOutWare',
          name: 'totalOutWare',
          component: totalOutWare,
          meta: {
            requireAuth: true,
            title: '销售汇总单',
          },

        },

        {
          path: '/shoppingDocument',
          name: 'shoppingDocument',
          component: shoppingDocument,
          meta: {
            requireAuth: true,
            title: '采买单管理',
          },
        },

        {
          path: '/separateDoc',
          name: 'separateDoc',
          component: separateDoc,
          meta: {
            requireAuth: true,
            title: '分菜单管理',
          },
        },
        {
          path: '/separateDetail',
          name: 'separateDetail',
          component: separateDetail,
          meta: {
            requireAuth: true,
            title: '分拣明细',
            breadNumber: 2,
          },
        },
        {
          path: '/separateRemarks/:date',
          name: 'separateRemarks',
          component: separateRemarks,
          meta: {
            requireAuth: true,
            title: '分菜单备注',
            breadNumber: 2,
          },
        },
        {
          path: '/totalSellProducts',
          name: 'totalSellProducts',
          component: totalSellProducts,
          meta: {
            requireAuth: true,
            title: '生产汇总单',
          },
        },
        {
          path: '/sellProductsDetail',
          name: 'sellProductsDetail',
          component: sellProductsDetail,
          meta: {
            requireAuth: true,
            title: '生产汇总单详情',
            breadNumber: 2,
          },
        },
        {
          path: '/produceDetail',
          name: 'produceDetail',
          component: produceDetail,
          meta: {
            requireAuth: true,
            title: '生产明细',
            breadNumber: 3,
          },
        },
        {
          path: '/addProProduct',
          name: 'addProProduct',
          component: addProProduct,
          meta: {
            requireAuth: true,
            title: '添加生产产品',
            breadNumber: 3,
          },
        },
        {
          path: '/transferShop',
          name: 'transferShop',
          component: transferShop,
          meta: {
            requireAuth: true,
            title: '转换采购',
            breadNumber: 4,
          },
        },
        {
          path: '/totalMTSOut',
          name: 'totalMTSOut',
          component: totalMTSOut,
          meta: {
            requireAuth: true,
            title: 'MTS出库',

          },
        },
        {
          path: '/totalMTOOut',
          name: 'totalMTOOut',
          component: totalMTOOut,
          meta: {
            requireAuth: true,
            title: 'MTO出库',
          },
        },
        {
          path: '/totalOutWareDoc',
          name: 'totalOutWareDoc',
          component: totalOutWareDoc,
          meta: {
            requireAuth: true,
            title: '出库汇总单',
          },
        },
        {
          path: '/turnoverManage',
          name: 'turnoverManage',
          component: turnoverManage,
          meta: {
            requireAuth: true,
            title: '周转筐管理',
          },
        },
        {
          path: '/totalOutDetail',
          name: 'totalOutDetail',
          component: totalOutDetail,
          meta: {
            requireAuth: true,
            title: '出库详情',
            breadNumber: 2,
          },
        },
        {
          path: '/reportLoss',
          name: 'reportLoss',
          component: reportLoss,
          meta: {
            requireAuth: true,
            title: '报损',
            breadNumber: 2,
          },
        },
        {
          path: '/productDepartment',
          name: 'productDepartment',
          component: productDepartment,
          meta: {
            requireAuth: true,
            title: '生产部门管理',
          },
        },
        {
          path: '/totalDepositPurchase',
          name: 'totalDepositPurchase',
          component: totalDepositPurchase,
          meta: {
            requireAuth: true,
            title: '进销存汇总表',
          },
        },
        {
          path: '/productRankList',
          name: 'productRankList',
          component: productRankList,
          meta: {
            requireAuth: true,
            title: '商品销售排行',
          },
        },
        {
          path: '/singleRange',
          name: 'singleRange',
          component: singleRange,
          meta: {
            requireAuth: true,
            title: '总仓单品毛利表',
          },
        },
        {
          path: '/returnGoods',
          name: 'returnGoods',
          component: returnGoods,
          meta: {
            requireAuth: true,
            title: '销售退货单',
          },
        },
        {
          path: '/returnGoodsDetail/:detail',
          name: 'returnGoodsDetail',
          component: returnGoodsDetail,
          meta: {
            requireAuth: true,
            title: '销售退货单详情',
            breadNumber: 2,
          },
        },
        {
          path: '/tcCodeManage',
          name: 'tcCodeManage',
          component: tcCodeManage,
          meta: {
            requireAuth: true,
            title: '产品编码管理',
            breadNumber: 2,
          },
        },
        {
          path: '/kindAddPoint/:detail',
          name: 'kindAddPoint',
          component: kindAddPoint,
          meta: {
            requireAuth: true,
            title: '设置加点',
            breadNumber: 2,
          },
        },
        {
          path: '/priceGroup',
          name: 'priceGroup',
          component: priceGroup,
          meta: {
            requireAuth: true,
            title: '销售报价分组',
          },
        },
        {
          path: '/clientGroup',
          name: 'clientGroup',
          component: clientGroup,
          meta: {
            requireAuth: true,
            title: '项目点分组管理',
          },
        },
        {
          path: '/matchClientGroup',
          name: 'matchClientGroup',
          component: matchClientGroup,
          meta: {
            requireAuth: true,
            title: '匹配客户',
            breadNumber: 2,
          },
        },
        {
          path: '/matchPriceGroup/:detail',
          name: 'matchPriceGroup',
          component: matchPriceGroup,
          meta: {
            requireAuth: true,
            title: '匹配客户',
            breadNumber: 2,
          },
        },
        {
          path: '/adjust',
          name: 'adjust',
          component: adjust,
          meta: {
            requireAuth: true,
            title: '调拨',
          },
        },
        {
          path: '/adjust_out',
          name: 'adjust_out',
          component: adjust_out,
          meta: {
            requireAuth: true,
            title: '调拨出库',
          },
        },
        {
          path: '/adjust_out_detail/:id',
          name: 'adjust_out_detail',
          component: adjust_out_detail,
          meta: {
            requireAuth: true,
            title: '出库单详情',
            breadNumber: 2,
          },
        },
        {
          path: '/adjust_product/:id',
          name: 'adjust_product',
          component: adjust_product,
          meta: {
            requireAuth: true,
            title: '调拨产品',
            breadNumber: 3,
          },
        },
        {
          path: '/adjust_enter',
          name: 'adjust_enter',
          component: adjust_enter,
          meta: {
            requireAuth: true,
            title: '调拨入库',
          },
        },
        {
          path: '/adjust_enter_detail/:id',
          name: 'adjust_enter_detail',
          component: adjust_enter_detail,
          meta: {
            requireAuth: true,
            title: '入库单详情',
            breadNumber: 2,
          },
        },
        {
          path: '/supplierLicense/:detail',
          name: 'supplierLicense',
          component: supplierLicense,
          meta: {
            requireAuth: true,
            title: '资质管理',
            breadNumber: 2,
          },
        },
        {
          path: '/uploadLicense',
          name: 'uploadLicense',
          component: uploadLicense,
          meta: {
            requireAuth: true,
            title: '上传凭证',
            breadNumber: 3,
          },
        },
        {
          path: '/TCGrossProfit',
          name: 'TCGrossProfit',
          component: TCGrossProfit,
          meta: {
            requireAuth: true,
            title: '客户毛利报表',
          },
        },
        {
          path: '/historicalInventory',
          name: 'historicalInventory',
          component: historicalInventory,
          meta: {
            requireAuth: true,
            title: '历史库存',
            breadNumber: 2,
          },
        },
        {
          path: '/priceChangeChart',
          name: 'priceChangeChart',
          component: priceChangeChart,
          meta: {
            requireAuth: true,
            title: '采购价格变化趋势',
          },
        },
        {
          path: '/sellOrderReturn',
          name: 'sellOrderReturn',
          component: sellOrderReturn,
          meta: {
            requireAuth: true,
            title: '销售退货单',
          },
        },
        {
          path: '/sellOrderReturnDetail/:detail',
          name: 'sellOrderReturnDetail',
          component: sellOrderReturnDetail,
          meta: {
            requireAuth: true,
            title: '销售退货单详情',
            breadNumber: 2,
          },
        },
        {
          path: '/AllOrderList',
          name: 'AllOrderList',
          component: AllOrderList,
          meta: {
            requireAuth: true,
            title: '全部订单列表(销售)',
          },
        },
        {
          path: '/allOrderDetail/:detail',
          name: 'allOrderDetail',
          component: allOrderDetail,
          meta: {
            requireAuth: true,
            title: '订单详情',
            breadNumber: 2,
          },
        },
        {
          path: '/productTracing',
          name: 'productTracing',
          component: productTracing,
          meta: {
            requireAuth: true,
            title: '产品溯源',
          },
        },
        {
          path: '/tracingContract/:id/:code',
          name: 'tracingContract',
          component: tracingContract,
          meta: {
            requireAuth: true,
            title: '单品溯源记录',
          },
        },
        {
          path: '/supplierContract/:id',
          name: 'supplierContract',
          component: supplierContract,
          meta: {
            requireAuth: true,
            title: '供应商资质',
          },
        },
        {
          path: '/supplierImg/:id',
          name: 'supplierImg',
          component: supplierImg,
          meta: {
            requireAuth: true,
            title: '资质图片',
          },
        },
        {
          path: '/configPrice',
          name: 'configPrice',
          component: configPrice,
          meta: {
            requireAuth: true,
            title: '比价配置',
            breadNumber: 2,
          },
        },
        {
          path: '/checkSku/:id',
          name: 'checkSku',
          component: checkSku,
          meta: {
            requireAuth: true,
            title: '查看SKU',
            breadNumber: 2,
          },
        },
        {
          path: '/compareDetail/:id',
          name: 'compareDetail',
          component: compareDetail,
          meta: {
            requireAuth: true,
            title: '查看供应商',
            breadNumber: 2,
          },
        },
        {
          path: '/comparePrice',
          name: 'comparePrice',
          component: comparePrice,
          meta: {
            requireAuth: true,
            title: '比价列表',
          },
        },
        {
          path: '/scName/:compareId/:recordId/:supplierId/:status',
          name: 'scName',
          component: scName,
          meta: {
            requireAuth: true,
            title: '查看大类',
            breadNumber: 3,
          },
        },
        {
          path: '/inputData/:id/:status',
          name: 'inputData',
          component: inputData,
          meta: {
            requireAuth: true,
            title: '发布报价',
            breadNumber: 2,
          },
        },
        {
          path: '/supplierDetail/:id/:status',
          name: 'supplierDetail',
          component: supplierDetail,
          meta: {
            requireAuth: true,
            title: '查看供应商',
            breadNumber: 2,
          },
        },
        {
          path: '/compareList',
          name: 'compareList',
          component: compareList,
          meta: {
            requireAuth: true,
            title: '竞价报价',
          },
        },
        {
          path: '/givePrice',
          name: 'givePrice',
          component: givePrice,
          meta: {
            requireAuth: true,
            title: '报价详情',
            breadNumber: 2,
          },
        },
        {
          path: '/checkProductPrice',
          name: 'checkProductPrice',
          component: checkProductPrice,
          meta: {
            requireAuth: true,
            title: '商品详情',
            breadNumber: 3,
          },
        },
        {
          path: '/mealCheckProductPrice',
          name: 'mealCheckProductPrice',
          component: mealCheckProductPrice,
          meta: {
            requireAuth: true,
            title: '商品详情',
            breadNumber: 3,
          },
        },
        {
          path: '/suPriceDetail/:id/:fCatId/:status',
          name: 'suPriceDetail',
          component: suPriceDetail,
          meta: {
            requireAuth: true,
            title: '查看报价',
            breadNumber: 4,
          },
        },
        {
          path: '/supplierCusHisOrderDetail/:detail',
          name: 'supplierCusHisOrderDetail',
          component: supplierCusHisOrderDetail,
          meta: {
            requireAuth: true,
            title: '订单详情',
            breadNumber: 2,
          },
        },
        {
          path: '/supplierCusAllOrderDetail/:detail',
          name: 'supplierCusAllOrderDetail',
          component: supplierCusAllOrderDetail,
          meta: {
            requireAuth: true,
            title: '订单详情',
            breadNumber: 2,
          },
        },
        {
          path: '/supplierCusNewOrderDetail/:detail',
          name: 'supplierCusNewOrderDetail',
          component: supplierCusNewOrderDetail,
          meta: {
            requireAuth: true,
            title: '订单详情',
            breadNumber: 2,
          },
        },
        {
          path: '/supplierCusConfirmOrderDetail/:detail',
          name: 'supplierCusConfirmOrderDetail',
          component: supplierCusConfirmOrderDetail,
          meta: {
            requireAuth: true,
            title: '订单详情',
            breadNumber: 2,
          },
        },
        {
          path: '/setting',
          name: 'setting',
          component: setting,
          meta: {
            requireAuth: true,
            title: '页面条数设置',
          },
        },
        {
          path: '/warehouseArea',
          name: 'warehouseArea',
          component: warehouseArea,
          meta: {
            requireAuth: true,
            title: '仓库区域管理',
          },
        },
        {
          path: '/warehousePosition',
          name: 'warehousePosition',
          component: warehousePosition,
          meta: {
            requireAuth: true,
            title: '库位管理',
          },
        },
        // 账号管理
        {
          path: '/accountManager',
          name: 'accountManager',
          component: accountManager,
          meta: {
            requireAuth: true,
            title: '人员管理',
          },
        },
        {
          path: '/queryRole/:detail',
          name: 'queryRole',
          component: queryRole,
          meta: {
            requireAuth: true,
            title: '人员角色',
            breadNumber: 2,
          },
        },
        {
          path: '/matchRole/:detail',
          name: 'matchRole',
          component: matchRole,
          meta: {
            requireAuth: true,
            title: '匹配人员角色',
            breadNumber: 3,
          },
        },
        {
          path: '/categoryManage',
          name: 'categoryManage',
          component: categoryManage,
          meta: {
            requireAuth: true,
            title: '品类管理',
          },
        },
        {
          path: '/secondCategory',
          name: 'secondCategory',
          component: secondCategory,
          meta: {
            requireAuth: true,
            title: '二级大类',
            breadNumber: 2,
          },
        },
        {
          path: '/thirdCategory',
          name: 'thirdCategory',
          component: thirdCategory,
          meta: {
            requireAuth: true,
            title: '三级大类',
            breadNumber: 3,
          },
        },
        {
          path: '/useSku',
          name: 'useSku',
          component: useSku,
          meta: {
            requireAuth: true,
            title: '产品列表',
          },
        },
        {
          path: '/productionEnterpriseManagement',
          name: 'productionEnterpriseManagement',
          component: productionEnterpriseManagement,
          meta: {
            requireAuth: true,
            title: '生产企业管理',
            breadNumber: 2,
          },
        },
        {
          path: '/purchaseLedger',
          name: 'purchaseLedger',
          component: purchaseLedger,
          meta: {
            requireAuth: true,
            title: '进销台账',
          },
        },
        {
          path: '/productQualification',
          name: 'productQualification',
          component: productQualification,
          meta: {
            requireAuth: true,
            title: '产品资质',
            breadNumber: 2,
          },
        },
        {
          path: '/temZoneManage',
          name: 'temZoneManage',
          component: temZoneManage,
          meta: {
            requireAuth: true,
            title: '温区管理',
          },
        },
        {
          path: '/projectProduct',
          name: 'projectProduct',
          component: projectProduct,
          meta: {
            requireAuth: true,
            title: '查看商品',
            breadNumber: 3,
          },
        },
        {
          path: '/forthCategory',
          name: 'forthCategory',
          component: forthCategory,
          meta: {
            requireAuth: true,
            title: '四级大类',
            breadNumber: 4,
          },
        },
        {
          path: '/matchSku/:detail',
          name: 'matchSku',
          component: matchSku,
          meta: {
            requireAuth: true,
            title: '匹配SKU',
            breadNumber: 2,
          },
        },
        {
          path: '/skuDetail/:detail',
          name: 'skuDetail',
          component: skuDetail,
          meta: {
            requireAuth: true,
            title: 'SKU详情',
            breadNumber: 2,
          },
        },
        {
          path: '/orderCostGrossProfit',
          name: 'orderCostGrossProfit',
          component: orderCostGrossProfit,
          meta: {
            requireAuth: true,
            title: '订单成本毛利表',
          },
        },
        // SMP标准sku
        {
          path: '/marryPageSku',
          name: 'marryPageSku',
          component: marryPageSku,
          meta: {
            requireAuth: true,
            title: '匹配页面',
            breadNumber: 2,
          },
        },
        {
          path: '/applicationSku',
          name: 'applicationSku',
          component: applicationSku,
          meta: {
            requireAuth: true,
            title: '申请记录',
            breadNumber: 2,
          },
        },
        {
          path: '/changeKeepSku',
          name: 'changeKeepSku',
          component: changeKeepSku,
          meta: {
            requireAuth: true,
            title: '替换/修改记录',
            breadNumber: 2,
          },
        },
        {
          path: '/staticSku',
          name: 'staticSku',
          component: staticSku,
          meta: {
            requireAuth: true,
            title: '标准Sku',
          },
        },
        // 银行账户
        {
          path: '/bankAccount',
          name: 'bankAccount',
          component: bankAccount,
          meta: {
            requireAuth: true,
            title: '银行账户',
          },
        },
        {
          path: '/bankAccountDetail',
          name: 'bankAccountDetail',
          component: bankAccountDetail,
          meta: {
            requireAuth: true,
            title: '银行账户详情',
            breadNumber: 2,
          },
        },
        // 实时现金流
        {
          path: '/cashFlow',
          name: 'cashFlow',
          component: cashFlow,
          meta: {
            requireAuth: true,
            title: '实时现金流',
          },
        },
        // 客户结算
        {
          path: '/customerSettlement',
          name: 'customerSettlement',
          component: customerSettlement,
          meta: {
            requireAuth: true,
            title: '客户结算',
          },
        },
        // 就餐人数设置
        {
          path: '/mealCountSet',
          name: 'mealCountSet',
          component: mealCountSet,
          meta: {
            requireAuth: true,
            title: '就餐人数配置',
          },
        },
        // 套餐配置
        {
          path: '/packageSet',
          name: 'packageSet',
          component: packageSet,
          meta: {
            requireAuth: true,
            title: '套餐配置',
          },
        },
        // 为套餐配置菜品
        {
          path: '/matchDishes',
          name: 'matchDishes',
          component: matchDishes,
          meta: {
            requireAuth: true,
            title: '配置菜品',
            breadNumber: 2,
          },
        },
        // 菜单管理
        {
          path: '/mealGroup',
          name: 'mealGroup',
          component: mealGroup,
          meta: {
            requireAuth: true,
            title: '菜单管理',
          },
        },
        // 编辑菜单
        {
          path: '/editRecipe',
          name: 'editRecipe',
          component: editRecipe,
          meta: {
            requireAuth: true,
            title: '编辑菜单',
            breadNumber: 2,
          },
        },

        // 销售单审核
        {
          path: '/salesOrderAudit',
          name: 'salesOrderAudit',
          component: salesOrderAudit,
          meta: {
            requireAuth: true,
            title: '销售单审核（转采购）',
          },
        },
        // 销售单审核-打印
        {
          path: '/printPreview',
          name: 'printPreview',
          component: printPreview,
          meta: {
            requireAuth: true,
            title: '打印预览',
          },
        },
        // 订单详情
        {
          path: '/salesOrderAuditDetail/:id',
          name: 'salesOrderAuditDetail',
          component: salesOrderAuditDetail,
          meta: {
            requireAuth: true,
            title: '订单详情',
            breadNumber: 2,
          },
        },
        // 配送中心订单详情
        {
          path: '/s_distributionCenterPendingOrderDetail/:detail',
          name: 's_distributionCenterPendingOrderDetail',
          component: s_distributionCenterPendingOrderDetail,
          meta: {
            requireAuth: true,
            title: '配送中心订单详情',
            breadNumber: 2,
          },
        },
        // 配送中心验收
        {
          path: '/s_distributionCenterOrderCheck/:detail',
          name: 's_distributionCenterOrderCheck',
          component: s_distributionCenterOrderCheck,
          meta: {
            requireAuth: true,
            title: '配送中心验收',
            breadNumber: 2,
          },
        },
        // 针对项目上架产品
        {
          path: '/addProjectProduct',
          name: 'addProjectProduct',
          component: addProjectProduct,
          meta: {
            requireAuth: true,
            title: '产品上架',
            breadNumber: 4,
          },
        },
        // 人员管理
        {
          path: '/personDetail',
          name: 'personDetail',
          component: personDetail,
          meta: {
            requireAuth: true,
            title: '人员列表',
            breadNumber: 2,
          },
        },
        // 减单审核
        {
          path: '/reducedOrder',
          name: 'reducedOrder',
          component: reducedOrder,
          meta: {
            requireAuth: true,
            title: '减单审核',
          },
        },
        // 价格审核
        {
          path: '/priceAudit',
          name: 'priceAudit',
          component: priceAudit,
          meta: {
            requireAuth: true,
            title: '价格审核',
          },
        },
        // 采购价审核
        {
          path: '/purchaseAudit',
          name: 'purchaseAudit',
          component: purchaseAudit,
          meta: {
            requireAuth: true,
            title: '采购价审核',
          },
        },
        // SKU审核
        {
          path: '/skuAudit',
          name: 'skuAudit',
          component: skuAudit,
          meta: {
            requireAuth: true,
            title: 'SKU审核',
          },
        },
        // 订单查询
        {
          path: '/searchSellOrder',
          name: 'searchSellOrder',
          component: searchSellOrder,
          meta: {
            requireAuth: true,
            title: '订单查询',
          },
        },
        // 订单查询详情
        {
          path: '/searchSellOrderDetail/:detail',
          name: 'searchSellOrderDetail',
          component: searchSellOrderDetail,
          meta: {
            requireAuth: true,
            title: '订单查询详情',
            breadNumber: 2,
          },
        },
        // 采购产品
        {
          path: '/purchaseAddProduct',
          name: 'purchaseAddProduct',
          component: purchaseAddProduct,
          meta: {
            requireAuth: true,
            title: '采购产品',
          },
        },
        {
          path: '/shopCar',
          name: 'shopCar',
          component: shopCar,
          meta: {
            requireAuth: true,
            title: '购物车',
          },
        },
        {
          path: '/emergencyOrder',
          name: 'emergencyOrder',
          component: emergencyOrder,
          meta: {
            requireAuth: true,
            title: '应急下单',
          },
        },
        {
          path: '/shopConfirmOrderList',
          name: 'shopConfirmOrderList',
          component: shopConfirmOrderList,
          meta: {
            requireAuth: true,
            title: '待确认订单',
          },
        },
        {
          path: '/shopConfirmOrderDetail/:detail',
          name: 'shopConfirmOrderDetail',
          component: shopConfirmOrderDetail,
          meta: {
            requireAuth: true,
            title: '订单详情',
            breadNumber: 2,
          },
        },
        {
          path: '/supplierComfirmDetail/:detail',
          name: 'supplierComfirmDetail',
          component: supplierComfirmDetail,
          meta: {
            requireAuth: true,
            title: '订单详情',
            breadNumber: 2,
          },
        },
        {
          path: '/searchShopOrder',
          name: 'searchShopOrder',
          component: searchShopOrder,
          meta: {
            requireAuth: true,
            title: '订单查询',
          },
        },
        // 手动入库
        {
          path: '/manualInstock',
          name: 'manualInstock',
          component: manualInstock,
          meta: {
            requireAuth: true,
            title: '手动入库',
            breadNumber: 2,
          },
        },
        {
          path: '/giftsInstock',
          name: 'giftsInstock',
          component: giftsInstock,
          meta: {
            requireAuth: true,
            title: '赠品入库',
            breadNumber: 2,
          },
        },
        {
          path: '/temporaryStock',
          name: 'temporaryStock',
          component: temporaryStock,
          meta: {
            requireAuth: true,
            title: '临时仓',
          },
        },
        // 库存预警
        {
          path: '/stockWarning',
          name: 'stockWarning',
          component: stockWarning,
          meta: {
            requireAuth: true,
            title: '库存预警',
          },
        },
        // 拣货单
        {
          path: '/pickingList',
          name: 'pickingList',
          component: pickingList,
          meta: {
            requireAuth: true,
            title: '拣货单',
          },
        },
        // 手动入库记录
        {
          path: '/manualInstockDetail',
          name: 'manualInstockDetail',
          component: manualInstockDetail,
          meta: {
            requireAuth: true,
            title: '手动入库记录',
            breadNumber: 2,
          },
        },
        // 二次出库
        {
          path: '/secondOut',
          name: 'secondOut',
          component: secondOut,
          meta: {
            requireAuth: true,
            title: '二次出库',
            breadNumber: 2,
          },
        },
        // 拣货单详情
        {
          path: '/pickingListDetail',
          name: 'pickingListDetail',
          component: pickingListDetail,
          meta: {
            requireAuth: true,
            title: '拣货单详情',
            breadNumber: 2,
          },
        },
        // 退货仓
        {
          path: '/returnStock',
          name: 'returnStock',
          component: returnStock,
          meta: {
            requireAuth: true,
            title: '退货仓',
          },
        },
        // 第三方供货关系管理
        {
          path: '/releationManage',
          name: 'releationManage',
          component: releationManage,
          meta: {
            requireAuth: true,
            title: '第三方供货关系管理',
          },
        },
        // 第三方产品供货关系绑定
        {
          path: '/releationDetail/:detail',
          name: 'releationDetail',
          component: releationDetail,
          meta: {
            requireAuth: true,
            title: '供应产品管理',
            breadNumber: 2,
          },
        },
        {
          path: '/supplierSendOrder',
          name: 'supplierSendOrder',
          component: supplierSendOrder,
          meta: {
            requireAuth: true,
            title: '转换订单',
          },
        },
        {
          path: '/supplierSendOrderDetail/:detail',
          name: 'supplierSendOrderDetail',
          component: supplierSendOrderDetail,
          meta: {
            requireAuth: true,
            title: '订单详情',
            breadNumber: 2,
          },
        },
        // 转换后变更产品
        {
          path: '/changeProductsAfterConversion',
          name: 'changeProductsAfterConversion',
          component: changeProductsAfterConversion,
          meta: {
            requireAuth: true,
            title: '转换后变更产品',
            breadNumber: 2,
          },
        },
        // 农残检测
        {
          path: '/pesticideResidueDetection',
          name: 'pesticideResidueDetection',
          component: pesticideResidueDetection,
          meta: {
            requireAuth: true,
            title: '农残检测',
          },
        },
        // 资质审核
        // {
        //   path: '/qualificationInspection',
        //   name: 'qualificationInspection',
        //   component: qualificationInspection,
        //   meta: {
        //     requireAuth: true,
        //     title: '资质审核',
        //   },
        // },

        // 销售价复核
        {
          path: '/salesPriceReview',
          name: 'salesPriceReview',
          component: salesPriceReview,
          meta: {
            requireAuth: true,
            title: '销售价复核',
          },
        },
        // 客户定价复核
        {
          path: '/customerPricingReview',
          name: 'customerPricingReview',
          component: customerPricingReview,
          meta: {
            requireAuth: true,
            title: '客户定价复核',
          },
        },
        // 送货差异表
        {
          path: '/deliveryDiscrepancy',
          name: 'deliveryDiscrepancy',
          component: deliveryDiscrepancy,
          meta: {
            requireAuth: true,
            title: '送货差异表',
          },
        },
        // 盘库审核
        {
          path: '/stockCheckAudit',
          name: 'stockCheckAudit',
          component: stockCheckAudit,
          meta: {
            requireAuth: true,
            title: '盘库审核',
          },
        },
        // 盘库审核-盘库单详情
        {
          path: '/stockCheckAuditDetail/:id/:pkc/:status',
          name: 'stockCheckAuditDetail',
          component: stockCheckAuditDetail,
          meta: {
            requireAuth: true,
            title: '盘库单详情',
            breadNumber: 2,
          },
        },
        // 领料退货单
        {
          path: '/pickingDocReturn',
          name: 'pickingDocReturn',
          component: pickingDocReturn,
          meta: {
            requireAuth: true,
            title: '领料退货单',
          },
        },
        // 领料退货单-领料退货单详情
        {
          path: '/pickingDocReturnDetail/:id',
          name: 'pickingDocReturnDetail',
          component: pickingDocReturnDetail,
          meta: {
            requireAuth: true,
            title: '领料退货单详情',
            breadNumber: 2,
          },
        },
        // 关账设置
        {
          path: '/financeCloseBill',
          name: 'financeCloseBill',
          component: financeCloseBill,
          meta: {
            requireAuth: true,
            title: '关账设置',
          },
        },
        // 生产领料退库单
        {
          path: '/proPickingDocReturn',
          name: 'proPickingDocReturn',
          component: proPickingDocReturn,
          meta: {
            requireAuth: true,
            title: '生产领料退库单',
          },
        },
        // 生产领料退库单详情
        {
          path: '/proPickingDocReturnDetail/:id',
          name: 'proPickingDocReturnDetail',
          component: proPickingDocReturnDetail,
          meta: {
            requireAuth: true,
            title: '生产领料退库单详情',
            breadNumber: 2,
          },
        },
        // 供应商管理-供货能力
        {
          path: '/supplyCapacity/:sid',
          name: 'supplyCapacity',
          component: supplyCapacity,
          meta: {
            requireAuth: true,
            title: '供货能力',
            breadNumber: 2,
          },
        },
        // 分拣配送-分拣组管理
        {
          path: '/sortingGroupManagement',
          name: 'sortingGroupManagement',
          component: sortingGroupManagement,
          meta: {
            requireAuth: true,
            title: '分拣组管理',
          },
        },
        // 分拣配送-分拣组管理-匹配项目
        {
          path: '/sortingGroupMatchedProjrct/:id',
          name: 'sortingGroupMatchedProjrct',
          component: sortingGroupMatchedProjrct,
          meta: {
            requireAuth: true,
            title: '匹配项目',
            breadNumber: 2,
          },
        },
        // 分拣配送-分拣组管理-匹配项目-新增匹配项目
        {
          path: '/sortingGroupMatchProjrct/:id',
          name: 'sortingGroupMatchProjrct',
          component: sortingGroupMatchProjrct,
          meta: {
            requireAuth: true,
            title: '新增匹配项目',
            breadNumber: 3,
          },
        },
        // 财务中心-发票列表
        {
          path: '/invoiceList',
          name: 'invoiceList',
          component: invoiceList,
          meta: {
            requireAuth: true,
            title: '发票列表',
          },
        },
        // 发票模态框
        {
          path: '/invoiceForm',
          name: 'invoiceForm',
          component: invoiceForm,
          meta: {
            requireAuth: true,
            title: '发票模态框',
          },
        },
        // 业务参考价
        {
          path: '/businessReferencePrice',
          name: 'businessReferencePrice',
          component: businessReferencePrice,
          meta: {
            requireAuth: true,
            title: '业务参考价',
          },
        },
        // 销售价格查询
        {
          path: '/salesPriceInquiry',
          name: 'salesPriceInquiry',
          component: salesPriceInquiry,
          meta: {
            requireAuth: true,
            title: '销售价格查询',
          },
        },
        // 采购价格查询
        {
          path: '/purchasePriceInquiry',
          name: 'purchasePriceInquiry',
          component: purchasePriceInquiry,
          meta: {
            requireAuth: true,
            title: '采购价格查询',
          },
        },
        // 审核-供应商客户退货审核详情
        {
          path: '/returnAuditSupplierCusDetail/:gid/:aid',
          name: 'returnAuditSupplierCusDetail',
          component: returnAuditSupplierCusDetail,
          meta: {
            requireAuth: true,
            title: '供应商客户退货审核详情',
            breadNumber: 2,
          },
        },
        // 报表-销售退货单-销售退货单详情
        {
          path: '/SupplierCusSalesReturnProductDetail/:srid',
          name: 'SupplierCusSalesReturnProductDetail',
          component: SupplierCusSalesReturnProductDetail,
          meta: {
            requireAuth: true,
            title: '销售退货单详情',
            breadNumber: 2,
          },
        },
        // 报表-供应商单品采购汇总表
        {
          path: '/supplierSingleItemProcurementSummary',
          name: 'supplierSingleItemProcurementSummary',
          component: supplierSingleItemProcurementSummary,
          meta: {
            requireAuth: true,
            title: '供应商单品采购汇总表',
          },
        },
        // 报表-销售退库单-销售退库单详情
        {
          path: '/returnWareSupplierCusDetail/:swrid',
          name: 'returnWareSupplierCusDetail',
          component: returnWareSupplierCusDetail,
          meta: {
            requireAuth: true,
            title: '销售退库单详情',
            breadNumber: 2,
          },
        },
        // 数据分析-数据看板
        {
          path: '/dataBoard',
          name: 'dataBoard',
          component: dataBoard,
          meta: {
            requireAuth: true,
            title: '数据看板',
          },
        },

        // 分拣配送-周转筐管理-周转筐列表
        {
          path: '/turnoverList',
          name: 'turnoverList',
          component: turnoverList,
          meta: {
            requireAuth: true,
            title: '周转筐列表',
            breadNumber: 2,
          },
        },
        // 仓库管理-出库-录入出库数据
        {
          path: '/manualStockOut',
          name: 'manualStockOut',
          component: manualStockOut,
          meta: {
            requireAuth: true,
            title: '录入出库数据',
            breadNumber: 2,
          },
        },
        // 报表-采购退货出库单
        {
          path: '/purchaseReturnStockOut',
          name: 'purchaseReturnStockOut',
          component: purchaseReturnStockOut,
          meta: {
            requireAuth: true,
            title: '采购退货出库单',
          },
        },
        // 报表-采购退货出库单-采购退货出库单详情
        {
          path: '/purchaseReturnStockOutDetail/:detail',
          name: 'purchaseReturnStockOutDetail',
          component: purchaseReturnStockOutDetail,
          meta: {
            requireAuth: true,
            title: '采购退货出库单详情',
            breadNumber: 2,
          },
        },
        // DS订单
        {
          path: '/DSOrder',
          name: 'DSOrder',
          component: DSOrder,
          meta: {
            requireAuth: true,
            title: '待送订单(第三方)',
          },
        },
        {
          path: '/DSOrderDetail/:detail',
          name: 'DSOrderDetail',
          component: DSOrderDetail,
          meta: {
            requireAuth: true,
            title: '待送订单详情',
            breadNumber: 2,
          },
        },
        {
          path: '/DSOrderConfirmList',
          name: 'DSOrderConfirmList',
          component: DSOrderConfirmList,
          meta: {
            requireAuth: true,
            title: '待确认订单(第三方)',
          },
        },
        {
          path: '/DSHistoryOrderList',
          name: 'DSHistoryOrderList',
          component: DSHistoryOrderList,
          meta: {
            requireAuth: true,
            title: '历史订单(第三方)',
          },
        },
        {
          path: '/DSOrdeInquiry',
          name: 'DSOrdeInquiry',
          component: DSOrdeInquiry,
          meta: {
            requireAuth: true,
            title: '订单查询',
          },
        },
        {
          path: '/DSOrdeInquiryDetail/:id',
          name: 'DSOrdeInquiryDetail',
          component: DSOrdeInquiryDetail,
          meta: {
            requireAuth: true,
            title: '订单查询详情',
            breadNumber: 2,
          },
        },

        {
          path: '/DSConfirmDetail/:detail',
          name: 'DSConfirmDetail',
          component: DSConfirmDetail,
          meta: {
            requireAuth: true,
            title: '待确认订单详情',
            breadNumber: 2,
          },
        },
        {
          path: '/DSHistoryDetail/:detail',
          name: 'DSHistoryDetail',
          component: DSHistoryDetail,
          meta: {
            requireAuth: true,
            title: '历史订单详情',
            breadNumber: 2,
          },
        },
        {
          path: '/businessGrossProfitTable',
          name: 'businessGrossProfitTable',
          component: businessGrossProfitTable,
          meta: {
            requireAuth: true,
            title: '业务部毛利表',
          },
        },
        {
          path: '/warehouseTransceiverList',
          name: 'warehouseTransceiverList',
          component: warehouseTransceiverList,
          meta: {
            requireAuth: true,
            title: '仓库收发明细表',
          },
        },
        {
          path: '/purchasePriceDifferenceTable',
          name: 'purchasePriceDifferenceTable',
          component: purchasePriceDifferenceTable,
          meta: {
            requireAuth: true,
            title: '采购部差价表',
          },
        },
        {
          path: '/safetyStockWarning',
          name: 'safetyStockWarning',
          component: safetyStockWarning,
          meta: {
            requireAuth: true,
            title: '安全库存预警',
            breadNumber: 2,
          },
        },
        {
          path: '/priceIncreaseRelationshipManagement',
          name: 'priceIncreaseRelationshipManagement',
          component: priceIncreaseRelationshipManagement,
          meta: {
            requireAuth: true,
            title: '加价关系管理',
          },
        },
        {
          path: '/supplierPrice',
          name: 'supplierPrice',
          component: supplierPrice,
          meta: {
            requireAuth: true,
            title: '成本中心',
          },
        },
        {
          path: '/orderProfitAnalysis',
          name: 'orderProfitAnalysis',
          component: orderProfitAnalysis,
          meta: {
            requireAuth: true,
            title: '订单利润分析',
          },
        },
        {
          path: '/projectProfitAnalysis',
          name: 'projectProfitAnalysis',
          component: projectProfitAnalysis,
          meta: {
            requireAuth: true,
            title: '项目利润分析',
          },
        },

        {
          path: '/priceRules',
          name: 'priceRules',
          component: priceRules,
          meta: {
            requireAuth: true,
            title: '价格规则',
          },
        },
        {
          path: '/newAddPrice/:SCHEME_ID',
          name: 'newAddPrice',
          component: newAddPrice,
          meta: {
            requireAuth: true,
            title: '新增加价方案',
          },
        },
        {
          path: '/updateAddPrice/:SCHEME_ID',
          name: 'updateAddPrice',
          component: updateAddPrice,
          meta: {
            requireAuth: true,
            title: '修改加价方案',
            breadNumber: 2,
          },
        },
        {
          path: '/priceRangePlus/:SCHEME_ID',
          name: 'priceRangePlus',
          component: priceRangePlus,
          meta: {
            requireAuth: true,
            title: '价格区间加点',
            breadNumber: 3,
          },
        },
        {
          path: '/specialPrice/:SCHEME_ID',
          name: 'specialPrice',
          component: specialPrice,
          meta: {
            requireAuth: true,
            title: '特殊产品加点',
            breadNumber: 2,
          },
        },
        {
          path: '/newProjectProduct/:RELATION_ID',
          name: 'newProjectProduct',
          component: newProjectProduct,
          meta: {
            requireAuth: true,
            title: '配置单品',
            breadNumber: 2,
          },
        },
        {
          path: '/customerPricingDifferenceQuery',
          name: 'customerPricingDifferenceQuery',
          component: customerPricingDifferenceQuery,
          meta: {
            requireAuth: true,
            title: '客户定价差异查询',
          },
        },
        {
          path: '/priceAdjustmentRecordsList',
          name: 'priceAdjustmentRecordsList',
          component: priceAdjustmentRecordsList,
          meta: {
            requireAuth: true,
            title: '订单调价申请记录',
          },
        },
        {
          path: '/priceAdjustmentDetail/:detail',
          name: 'priceAdjustmentDetail',
          component: priceAdjustmentDetail,
          meta: {
            requireAuth: true,
            title: '订单调价申请记录',
            breadNumber: 2,
          },
        },
        // 报表-销售报表-详情
        {
          path: '/salesStatementsDetail/:detail',
          name: 'salesStatementsDetail',
          component: salesStatementsDetail,
          meta: {
            requireAuth: true,
            title: '销售报表详情',
            breadNumber: 2,
          },
        },
        // 报表-采购报表-详情
        {
          path: '/purchaseDetail/:detail',
          name: 'purchaseDetail',
          component: purchaseDetail,
          meta: {
            requireAuth: true,
            title: '采购报表详情',
            breadNumber: 2,
          },
        },
        // 报表-采购报表-详情
        {
          path: '/TCGrossProfitDetail/:detail',
          name: 'TCGrossProfitDetail',
          component: TCGrossProfitDetail,
          meta: {
            requireAuth: true,
            title: '毛利表详情',
            breadNumber: 2,
          },
        },
        // 财务中心-供应商客户结算-结算列表
        {
          path: '/supplierCustomerOrderList/:detail',
          name: 'supplierCustomerOrderList',
          component: supplierCustomerOrderList,
          meta: {
            requireAuth: true,
            title: '结算列表',
            breadNumber: 2,
          },
        },
        // 财务中心-供应商客户结算-开票明细
        {
          path: '/supplierCustomerInvoiceDetails/:detail',
          name: 'supplierCustomerInvoiceDetails',
          component: supplierCustomerInvoiceDetails,
          meta: {
            requireAuth: true,
            title: '开票明细',
            breadNumber: 2,
          },
        },
        // 财务中心-供应商客户结算-结算列表-订单详情
        {
          path: '/supplierCustomerOrderDayList/:detail',
          name: 'supplierCustomerOrderDayList',
          component: supplierCustomerOrderDayList,
          meta: {
            requireAuth: true,
            title: '订单详情',
            breadNumber: 3,
          },
        },
        // 销售订单管理-单外订单
        {
          path: '/lowPriceOrderList',
          name: 'lowPriceOrderList',
          component: lowPriceOrderList,
          meta: {
            requireAuth: true,
            title: '单外订单',
          },
        },
        // 销售订单管理-单外订单-单外订单详情
        {
          path: '/lowPriceOrderListDetail/:detail',
          name: 'lowPriceOrderListDetail',
          component: lowPriceOrderListDetail,
          meta: {
            requireAuth: true,
            title: '单外订单详情',
            breadNumber: 2,
          },
        },
        // 销售订单管理-无实发订单确认
        {
          path: '/NoActualOrderConfirmation',
          name: 'NoActualOrderConfirmation',
          component: NoActualOrderConfirmation,
          meta: {
            requireAuth: true,
            title: '无实发订单确认',
          },
        },


        // 预约下载
        {
          path: '/appointmentHandling',
          name: 'appointmentHandling',
          component: appointmentHandling,
          meta: {
            requireAuth: true,
            title: '预约下载',
          },
        },

        // 销售订单管理-录入订单
        {
          path: '/addLowPriceOrder/:detail',
          name: 'addLowPriceOrder',
          component: addLowPriceOrder,
          meta: {
            requireAuth: true,
            title: '录入订单',
            breadNumber: 2,
          },
        },
        // 报表-采购退货单-录入采购退货单
        {
          path: '/enterPurchaseReturnOrder',
          name: 'enterPurchaseReturnOrder',
          component: enterPurchaseReturnOrder,
          meta: {
            requireAuth: true,
            title: '录入采购退货单',
            breadNumber: 2,
          },
        },
        // 报表-供应商单品采购汇总表
        {
          path: '/projectSalesDailySummary',
          name: 'projectSalesDailySummary',
          component: projectSalesDailySummary,
          meta: {
            requireAuth: true,
            title: '供应商单品采购汇总表',
          },
        },
        // 价格管理-供应商报价记录-比价结果
        {
          path: '/priceComparitionResult',
          name: 'priceComparitionResult',
          component: priceComparitionResult,
          meta: {
            requireAuth: true,
            title: '比价结果',
            breadNumber: 2,
          },
        },
        // 第三方配送订单-转换订单列表-转换存疑产品清单
        {
          path: '/thirdPartyTransferErrorProductList',
          name: 'thirdPartyTransferErrorProductList',
          component: thirdPartyTransferErrorProductList,
          meta: {
            requireAuth: true,
            title: '转换存疑产品清单',
            breadNumber: 2,
          },
        },
        // 第三方配送订单-转换订单列表-转换存疑产品清单2.0
        {
          path: '/thirdPartyTransferErrorProductList_test',
          name: 'thirdPartyTransferErrorProductList_test',
          component: thirdPartyTransferErrorProductList_test,
          meta: {
            requireAuth: true,
            title: '转换存疑产品清单',
            breadNumber: 2,
          },
        },
        // 仓库管理-出库验收差异
        {
          path: '/differenceBetweenOutboundAndAcceptance',
          name: 'differenceBetweenOutboundAndAcceptance',
          component: differenceBetweenOutboundAndAcceptance,
          meta: {
            requireAuth: true,
            title: '出库验收差异',
          },
        },
        // 报表-订单产品毛利表
        {
          path: '/orderProductGrossProfitTable',
          name: 'orderProductGrossProfitTable',
          component: orderProductGrossProfitTable,
          meta: {
            requireAuth: true,
            title: '订单产品毛利表',
          },
        },
        // 制单管理-配送单管理(司渊)
        {
          path: '/sendingDocumentSupplier',
          name: 'sendingDocumentSupplier',
          component: sendingDocumentSupplier,
          meta: {
            requireAuth: true,
            title: '配送单管理(司渊)',
          },
        },
        {
          path: '/DSUnpriceOrderDetail',
          name: 'DSUnpriceOrderDetail',
          component: DSUnpriceOrderDetail,
          meta: {
            requireAuth: true,
            title: '未定价订单详情列表',
          },
        },
      ],
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js